/* Supps247 site effects bundle, built 10 Oct 2026. Loaded with defer. Each part is isolated so one error cannot stop the others. */
/* ---- from snippets/mlyn-anim.liquid ---- */
try {
(function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var designMode = window.Shopify && window.Shopify.designMode;

    // Fade-in on scroll: template sections that start below the first screen only.
    try {
      /* 10 Oct 2026: browsers with scroll-linked CSS use the new scroll motion instead (see s247-new part) */
      if (!reduce && !designMode && 'IntersectionObserver' in window && !(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'))) {
        var all = [].slice.call(document.querySelectorAll('[id^="shopify-section-template--"]'));
        var vh = window.innerHeight || 800;
        var secs = all.filter(function (s, i) { return i > 1 && s.getBoundingClientRect().top > vh; });
        if (secs.length) {
          document.documentElement.classList.add('mlyn-anim');
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              var t = e.target;
              t.classList.add('is-in');
              io.unobserve(t);
              setTimeout(function () { t.classList.remove('mlyn-reveal', 'is-in'); }, 900);
            });
          }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
          secs.forEach(function (s) { s.classList.add('mlyn-reveal'); io.observe(s); });
        }
      }
    } catch (err) {
      document.documentElement.classList.remove('mlyn-anim');
    }

    // Add-to-cart feedback: watch successful /cart/add requests.
    var lastBtn = null;
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button[name="add"], .add-to-cart-btn, .add_to_cart_button') : null;
      if (b) lastBtn = b;
    }, true);
    function celebrate() {
      if (reduce) return;
      [].forEach.call(document.querySelectorAll('.mlyn-cart-icon'), function (ic) {
        ic.classList.remove('mlyn-cart-bump'); void ic.offsetWidth; ic.classList.add('mlyn-cart-bump');
      });
      var b = lastBtn;
      if (b && document.body.contains(b) && b.offsetParent) {
        b.classList.remove('mlyn-atc-added'); void b.offsetWidth; b.classList.add('mlyn-atc-added');
        setTimeout(function () { b.classList.remove('mlyn-atc-added'); }, 1700);
      }
      lastBtn = null;
    }
    if (window.fetch && !window.__mlynFetchWrapped) {
      window.__mlynFetchWrapped = true;
      var origFetch = window.fetch;
      window.fetch = function (input) {
        var p = origFetch.apply(this, arguments);
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (/\/cart\/add/.test(url)) {
            p.then(function (res) { if (res && res.ok) celebrate(); }, function () {});
          }
        } catch (err) {}
        return p;
      };
    }
  })();
} catch (e) { if (window.console) console.warn("s247-fx mlyn-anim", e); }

/* ---- from snippets/mlyn-anim-pro.liquid ---- */
try {
(function () {
    var d = document, w = window, html = d.documentElement;
    var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var design = w.Shopify && w.Shopify.designMode;
    if (reduce) return;
    function safe(fn) { try { fn(); } catch (e) {} }
    function visImg(root) {
      if (!root) return null;
      var imgs = root.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        var cs = getComputedStyle(imgs[i]);
        if (imgs[i].offsetParent && cs.opacity !== '0' && imgs[i].getBoundingClientRect().width > 40) return imgs[i];
      }
      return imgs[0] || null;
    }
    function mainGals() {
      var g = d.querySelectorAll('[id*="mlyn_main_prodcut"] [id^="CustomGallery"]');
      if (!g.length) g = d.querySelectorAll('[id^="CustomGallery"]');
      return [].slice.call(g);
    }
    function mainGal() {
      var g = mainGals();
      for (var i = 0; i < g.length; i++) { if (g[i].offsetParent) return g[i]; }
      return g[0] || null;
    }
    function cartIcon() {
      var ics = d.querySelectorAll('.mlyn-cart-icon');
      for (var i = 0; i < ics.length; i++) { if (ics[i].offsetParent) return ics[i]; }
      return null;
    }

    /* 1 page transitions: name the clicked card photo */
    safe(function () {
      if (!('onpageswap' in w)) return;
      d.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('.mlyn-product-card a[href*="/products/"]');
        if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
        var card = a.closest('.mlyn-product-card');
        var img = visImg(card);
        if (!img) return;
        d.querySelectorAll('[style*="view-transition-name"]').forEach(function (el) { el.style.viewTransitionName = ''; });
        img.style.viewTransitionName = 'mlyn-product';
        try { sessionStorage.setItem('mlynVT', '1'); } catch (err) {}
      }, true);
      w.addEventListener('pageshow', function () {
        d.querySelectorAll('.mlyn-product-card img').forEach(function (el) { el.style.viewTransitionName = ''; });
      });
    });

    /* 2 fly-to-cart */
    safe(function () {
      d.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('button[name="add"], .add-to-cart-btn, .add_to_cart_button');
        if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true' || !w.Element.prototype.animate) return;
        var src = null, card = b.closest('.mlyn-product-card');
        if (card) src = visImg(card);
        if (!src && b.closest('#sticky-atc-bar')) src = visImg(mainGal()) || visImg(d.getElementById('sticky-atc-bar'));
        if (!src) src = visImg(mainGal());
        var icon = cartIcon();
        if (!src || !icon) return;
        var s = src.getBoundingClientRect(), t = icon.getBoundingClientRect();
        if (s.bottom < 0 || s.top > innerHeight) { s = b.getBoundingClientRect(); }
        var size = Math.min(140, Math.max(60, s.width * 0.5));
        var fly = src.cloneNode(false);
        fly.removeAttribute('srcset'); fly.removeAttribute('sizes'); fly.removeAttribute('loading'); fly.removeAttribute('class'); fly.removeAttribute('style');
        fly.src = src.currentSrc || src.src; fly.className = 'mlyn-fly'; fly.alt = '';
        var x0 = s.left + s.width / 2 - size / 2, y0 = s.top + s.height / 2 - size / 2;
        var x1 = t.left + t.width / 2 - size / 2, y1 = t.top + t.height / 2 - size / 2;
        fly.style.width = size + 'px'; fly.style.height = size + 'px'; fly.style.left = x0 + 'px'; fly.style.top = y0 + 'px';
        d.body.appendChild(fly);
        var dx = x1 - x0, dy = y1 - y0;
        fly.animate([
          { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
          { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - 90) + 'px) scale(.8) rotate(-8deg)', opacity: 1, offset: .45 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(12deg)', opacity: .35 }
        ], { duration: 780, easing: 'cubic-bezier(.45,.05,.3,1)', fill: 'forwards' }).onfinish = function () { fly.remove(); };
      }, true);
    });

    /* 3 product grid ripple entrance (cards below the first screen) */
    safe(function () {
      if (design || !('IntersectionObserver' in w) || (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'))) return; /* 10 Oct 2026: scroll-linked CSS handles this where supported */
      var cards = [].slice.call(d.querySelectorAll('ul.grid > li')).filter(function (li) {
        return li.querySelector('.mlyn-product-card') && !li.closest('.swiper') && li.getBoundingClientRect().top > innerHeight;
      });
      if (!cards.length) return;
      html.classList.add('mlyn-pro');
      var io = new IntersectionObserver(function (entries) {
        var n = 0;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target, delay = Math.min(n++, 6) * 70;
          io.unobserve(el);
          setTimeout(function () {
            el.classList.add('is-in');
            setTimeout(function () { el.classList.remove('mlyn-card-in', 'is-in'); }, 800);
          }, delay);
        });
      }, { rootMargin: '0px 0px -5% 0px', threshold: 0 });
      cards.forEach(function (li) { li.classList.add('mlyn-card-in'); io.observe(li); });
    });

    /* 4 flavour photo crossfade + hover zoom */
    if ('MutationObserver' in w) mainGals().forEach(function (gal) { safe(function () {
      function pop(img) { if (!img) return; img.classList.remove('mlyn-img-swap'); void img.offsetWidth; img.classList.add('mlyn-img-swap'); }
      var pend = 0;
      var mo = new MutationObserver(function (muts) {
        var slideAdded = false;
        muts.forEach(function (m) {
          if (m.type === 'attributes' && m.target.tagName === 'IMG' && m.target.closest('.swiper-slide')) pop(m.target);
          if (m.type === 'childList') {
            for (var i = 0; i < m.addedNodes.length; i++) {
              var n = m.addedNodes[i];
              if (n.nodeType === 1 && (n.classList.contains('swiper-slide') || n.querySelector && n.querySelector('.swiper-slide'))) slideAdded = true;
            }
          }
        });
        if (slideAdded && !pend) {
          pend = setTimeout(function () {
            pend = 0;
            var act = gal.querySelector('.swiper-slide-active img') || gal.querySelector('.swiper-slide img');
            pop(act);
          }, 60);
        }
      });
      mo.observe(gal, { attributes: true, attributeFilter: ['src'], subtree: true, childList: true });
      if (fine && innerWidth >= 1024) {
        gal.addEventListener('mousemove', function (e) {
          var a = e.target.closest && e.target.closest('a.glightbox');
          if (!a || !gal.contains(a)) return;
          var img = a.querySelector('img'); if (!img) return;
          var r = a.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
          if (!a.classList.contains('mlyn-zoom')) a.classList.add('mlyn-zoom');
        });
        gal.addEventListener('mouseleave', function () {
          gal.querySelectorAll('a.glightbox.mlyn-zoom').forEach(function (a) { a.classList.remove('mlyn-zoom'); });
        });
        gal.addEventListener('mouseout', function (e) {
          var a = e.target.closest && e.target.closest('a.glightbox');
          if (a && !a.contains(e.relatedTarget)) a.classList.remove('mlyn-zoom');
        });
      }
    }); });

    /* 5 card 3D tilt + shine (desktop) */
    safe(function () {
      if (!fine) return;
      var cur = null, raf = 0, ev = null;
      function wrap(card) {
        var a = card.querySelector('a.tw-relative.tw-block') || card.querySelector('a[href*="/products/"]');
        if (!a) return null;
        if (!a.classList.contains('mlyn-tilt')) {
          a.classList.add('mlyn-tilt');
          var sh = d.createElement('span'); sh.className = 'mlyn-shine'; a.appendChild(sh);
        }
        return a;
      }
      function reset(a) { if (a) a.style.transform = ''; }
      d.addEventListener('mousemove', function (e) {
        ev = e;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var card = ev.target.closest && ev.target.closest('.mlyn-product-card');
          var a = card ? wrap(card) : null;
          if (cur && cur !== a) reset(cur);
          cur = a;
          if (!a) return;
          var r = a.getBoundingClientRect();
          var px = (ev.clientX - r.left) / r.width, py = (ev.clientY - r.top) / r.height;
          if (px < 0 || px > 1 || py < 0 || py > 1) { reset(a); return; }
          a.style.transform = 'perspective(900px) rotateX(' + ((0.5 - py) * 8).toFixed(2) + 'deg) rotateY(' + ((px - 0.5) * 10).toFixed(2) + 'deg) scale(1.02)';
          a.style.setProperty('--sx', (px * 100).toFixed(1) + '%');
          a.style.setProperty('--sy', (py * 100).toFixed(1) + '%');
        });
      }, { passive: true });
      d.addEventListener('mouseleave', function () { reset(cur); cur = null; });
    });

    /* 6 count-up numbers */
    safe(function () {
      if (!('IntersectionObserver' in w)) return;
      var els = [].slice.call(d.querySelectorAll('[data-mlyn-count], [id*="store_banner"] p span'));
      els = els.filter(function (el) { return el.childElementCount === 0 && /^\s*\d[\d,]*(\.\d+)?\s*(\+|%|k\+?)?\s*$/i.test(el.textContent); });
      if (!els.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target; io.unobserve(el);
          var txt = el.textContent.trim(), m = txt.match(/^([\d,]+(?:\.\d+)?)(.*)$/);
          if (!m) return;
          var target = parseFloat(m[1].replace(/,/g, '')), suf = m[2], dec = (m[1].split('.')[1] || '').length, t0 = performance.now();
          el.style.fontVariantNumeric = 'tabular-nums';
          (function step(now) {
            var p = Math.min(1, (now - t0) / 1300), v = target * (1 - Math.pow(1 - p, 3));
            el.textContent = (dec ? v.toFixed(dec) : Math.round(v).toLocaleString('en-AU')) + suf;
            if (p < 1) requestAnimationFrame(step); else el.textContent = txt;
          })(t0);
        });
      }, { threshold: 0.6 });
      els.forEach(function (el) { io.observe(el); });
    });

    /* 7 price tick */
    safe(function () {
      var roots = [].slice.call(d.querySelectorAll('.current-price, #sticky-atc-bar'));
      if (!roots.length || !('MutationObserver' in w)) return;
      var last = new WeakMap();
      var mo = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          var el = m.target.nodeType === 3 ? m.target.parentElement : m.target;
          if (!el || !/\$/.test(el.textContent || '')) return;
          var tick = el.closest('.current-price') || el;
          var txt = tick.textContent;
          if (last.get(tick) === txt) return;
          last.set(tick, txt);
          if (tick.classList.contains('current-price')) {
            tick.classList.remove('mlyn-tick'); void tick.offsetWidth; tick.classList.add('mlyn-tick');
          } else if (tick.animate) {
            tick.animate([{ opacity: 0.2 }, { opacity: 1 }], { duration: 350, easing: 'ease-out' });
          }
        });
      });
      roots.forEach(function (r) { last.set(r, r.textContent); mo.observe(r, { childList: true, characterData: true, subtree: true }); });
    });

    /* 8 loading shimmer on product card photos */
    safe(function () {
      d.querySelectorAll('.mlyn-product-card').forEach(function (card) {
        var a = card.querySelector('a.tw-relative.tw-block');
        var img = a && a.querySelector('img');
        if (!img || (img.complete && img.naturalWidth)) return;
        a.classList.add('mlyn-skel');
        var done = function () { a.classList.remove('mlyn-skel'); };
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
        setTimeout(done, 12000);
      });
    });

    /* 9 blog reading progress */
    safe(function () {
      var bar = d.querySelector('.mlyn-progress');
      var art = d.querySelector('article[class*="article--"]') || d.querySelector('article');
      if (!bar || !art) return;
      var tick = 0;
      function upd() {
        tick = 0;
        var r = art.getBoundingClientRect(), total = r.height - innerHeight * 0.6;
        var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
        bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      }
      addEventListener('scroll', function () { if (!tick) tick = requestAnimationFrame(upd); }, { passive: true });
      upd();
    });

    /* 11 confetti when free shipping unlocks (once per session) */
    safe(function () {
      var key = 'mlynFsCelebrated';
      function done() { try { return sessionStorage.getItem(key); } catch (e) { return '1'; } }
      function burst(from) {
        if (!w.Element.prototype.animate) return;
        var r = from.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + 18;
        var cols = ['#4ccefe', '#1f8bca', '#10b981', '#fbbf24', '#f43f5e', '#ffffff'];
        for (var i = 0; i < 34; i++) {
          var p = d.createElement('span'); p.className = 'mlyn-confetti';
          p.style.left = cx + 'px'; p.style.top = cy + 'px'; p.style.background = cols[i % cols.length];
          d.body.appendChild(p);
          var ang = (Math.random() * Math.PI) + Math.PI, dist = 80 + Math.random() * 140;
          var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist;
          p.animate([
            { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
            { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + (Math.random() * 540) + 'deg)', opacity: 1, offset: .55 },
            { transform: 'translate(' + dx * 1.2 + 'px,' + (dy + 220) + 'px) rotate(' + (Math.random() * 900) + 'deg)', opacity: 0 }
          ], { duration: 1300 + Math.random() * 500, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' }).onfinish = (function (el) { return function () { el.remove(); }; })(p);
        }
      }
      function check() {
        if (done()) return;
        var bars = d.querySelectorAll('.mlyn-fsb.is-done');
        for (var i = 0; i < bars.length; i++) {
          if (bars[i].offsetParent) {
            try { sessionStorage.setItem(key, '1'); } catch (e) {}
            setTimeout(burst.bind(null, bars[i]), 650);
            return;
          }
        }
      }
      var hadUnder = !!d.querySelector('.mlyn-fsb:not(.is-done)');
      if (!hadUnder) { try { if (d.querySelector('.mlyn-fsb.is-done')) sessionStorage.setItem(key, '1'); } catch (e) {} }
      if ('MutationObserver' in w) {
        var pend = 0;
        new MutationObserver(function () {
          if (pend || done()) return;
          pend = setTimeout(function () { pend = 0; check(); }, 300);
        }).observe(d.body, { childList: true, subtree: true });
      }
    });

    /* 12 ripple + shine on main buttons */
    safe(function () {
      var sel = '.add-to-cart-btn:not(.button), .mlyn-view-allss';
      function mark() { d.querySelectorAll(sel).forEach(function (b) { if (!b.classList.contains('mlyn-fx')) b.classList.add('mlyn-fx'); }); }
      mark(); setTimeout(mark, 2500);
      d.addEventListener('pointerdown', function (e) {
        var b = e.target.closest && e.target.closest(sel);
        if (!b) return;
        b.classList.add('mlyn-fx');
        var r = b.getBoundingClientRect(), s = Math.max(r.width, r.height) * 2.2;
        var rp = d.createElement('span'); rp.className = 'mlyn-ripple';
        rp.style.width = rp.style.height = s + 'px';
        rp.style.left = (e.clientX - r.left - s / 2) + 'px'; rp.style.top = (e.clientY - r.top - s / 2) + 'px';
        b.appendChild(rp); setTimeout(function () { rp.remove(); }, 650);
      }, { passive: true });
    });

    /* 13 header shadow on scroll */
    safe(function () {
      var on = false, tk = 0;
      function upd() { tk = 0; var s = scrollY > 40; if (s !== on) { on = s; html.classList.toggle('mlyn-scrolled', s); } }
      addEventListener('scroll', function () { if (!tk) tk = requestAnimationFrame(upd); }, { passive: true });
      upd();
    });

    /* 14 magnetic buttons (desktop) */
    safe(function () {
      if (!fine) return;
      var sel = '.add-to-cart-btn:not(.button), .mlyn-view-allss';
      d.addEventListener('mousemove', function (e) {
        var b = e.target.closest && e.target.closest(sel);
        d.querySelectorAll('.mlyn-mag').forEach(function (x) { if (x !== b) x.style.transform = ''; });
        if (!b) return;
        b.classList.add('mlyn-mag');
        var r = b.getBoundingClientRect();
        var mx = (e.clientX - (r.left + r.width / 2)) / r.width, my = (e.clientY - (r.top + r.height / 2)) / r.height;
        b.style.transform = 'translate(' + (mx * 8).toFixed(1) + 'px,' + (my * 6).toFixed(1) + 'px)';
      }, { passive: true });
    });
  })();
} catch (e) { if (window.console) console.warn("s247-fx mlyn-anim-pro", e); }

/* ---- from snippets/mlyn-ui-pro.liquid ---- */
try {
(function () {
    /* 7 key facts: read the description text and show chips for the facts it contains */
    function fillFacts(box) {
      if (!box || box.dataset.done) return; box.dataset.done = '1';
      var t = (box.getAttribute('data-text') || '').replace(/\s+/g, ' ');
      var tags = box.getAttribute('data-tags') || '';
      var vs = servMap(box);
      var facts = [];
      function find(re, label, unit) {
        var m = t.match(re); if (m && !(label === 'servings' && parseInt(m[1], 10) < 5)) facts.push({ v: m[1] + (unit || ''), l: label });
      }
      find(/(\d{1,2}(?:\.\d)?)\s?g(?:rams)?\s(?:of\s)?(?:premium\s|whey\s|high[- ]quality\s)?protein/i, 'protein per serve', 'g');
      find(/(\d{3,4})\s?(?:calories|kcal|cal(?:s)?\b)/i, 'calories per serve', '');
      find(/(\d{1,2}(?:\.\d)?)\s?g\s(?:of\s)?(?:micronised\s|micronized\s)?creatine/i, 'creatine per serve', 'g');
      find(/(\d{2,4})\s?mg\s(?:of\s)?caffeine/i, 'caffeine per serve', 'mg');
      if (!vs) find(/(?:^|[^\d.])(\d{1,3})\s?(?:servings|serves)\b/i, 'servings', '');
      var tagFacts = [];
      if (/\bvegan\b/.test(tags)) tagFacts.push('Vegan');
      if (/gluten[- ]free/.test(tags)) tagFacts.push('Gluten free');
      if (/sugar[- ]free/.test(tags)) tagFacts.push('Sugar free');
      facts = facts.slice(0, vs ? 3 : 4);
      if (!facts.length && !tagFacts.length && !vs) return;
      var h = '';
      facts.forEach(function (f) { h += '<span class="mlyn-fact"><b>' + f.v + '</b>' + f.l + '</span>'; });
      if (vs) h += '<span class="mlyn-fact is-serv" style="display:none"></span>';
      tagFacts.slice(0, 2).forEach(function (f) { h += '<span class="mlyn-fact is-tag">' + f + '</span>'; });
      box.innerHTML = h; box.removeAttribute('hidden');
      if (vs) servSync(box);
    }

    /* 7b servings per size/flavour (6 Oct 2026): variants with a Servings value show their own number,
       and the chip follows the selected option. Products without per-variant values are unchanged. */
    function servMap(box) {
      var raw = box.getAttribute('data-vserv'); if (!raw) return null;
      try { var m = JSON.parse(raw); return (m && typeof m === 'object') ? m : null; } catch (e) { return null; }
    }
    function servCurrent(vs, box) {
      var ins = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
      for (var i = 0; i < ins.length; i++) { var v = String(ins[i].value || ''); if (v && Object.prototype.hasOwnProperty.call(vs, v)) return v; }
      try { var u = new URLSearchParams(location.search).get('variant'); if (u && Object.prototype.hasOwnProperty.call(vs, u)) return u; } catch (e) {}
      return box.getAttribute('data-vcur');
    }
    function servSync(box) {
      var vs = servMap(box); if (!vs) return;
      var chip = box.querySelector('.is-serv'); if (!chip) return;
      var id = servCurrent(vs, box), n = id ? vs[id] : null;
      if (chip.getAttribute('data-for') === String(id)) return;
      chip.setAttribute('data-for', String(id));
      if (n) { chip.innerHTML = '<b>' + n + '</b>servings'; chip.style.display = ''; }
      else { chip.innerHTML = ''; chip.style.display = 'none'; }
    }
    function servAll() { document.querySelectorAll('[data-mlyn-facts][data-vserv]').forEach(servSync); }
    if (document.querySelector('[data-mlyn-facts][data-vserv]') || document.readyState === 'loading') {
      document.addEventListener('change', function () { setTimeout(servAll, 60); }, true);
      document.addEventListener('click', function () { setTimeout(servAll, 150); }, true);
      window.addEventListener('popstate', servAll);
      setInterval(function () { if (document.querySelector('[data-mlyn-facts][data-vserv]')) servAll(); }, 1000);
    }

    /* 4b cart drawer and Eurus cards: add a "Save $X" tag next to struck-out prices */
    function money(n){ return '$' + (Math.round(n*100)/100).toFixed(2).replace(/\.00$/, ''); }
    function parse(t){ var m=(t||'').replace(/,/g,'').match(/\$\s?(\d+(?:\.\d+)?)/); return m?parseFloat(m[1]):null; }
    /* 8 Oct 2026: tags are now kept in step with the prices shown (updated or removed when the prices change,
       e.g. a different option is picked or a cart line changes). Savings under $1 are not tagged. */
    function saveTags(){
      document.querySelectorAll('.mlyn-pc-save-js:not(.mlyn-upto)').forEach(function(tag){
        var box=tag.closest('.price');
        if(!box||!box.querySelector('s.price-compare, s.cap')||!box.querySelector('.price-sale')) tag.remove();
      });
      document.querySelectorAll('.price s.price-compare, .price s.cap').forEach(function(sEl){
        var box=sEl.closest('.price'); if(!box) return;
        var sale=box.querySelector('.price-sale');
        var tag=box.querySelector('.mlyn-pc-save-js:not(.mlyn-upto)');
        var was=parse(sEl.textContent), now=sale?parse(sale.textContent):null;
        if(!sale||!was||!now||was-now<1){ if(tag) tag.remove(); return; }
        var txt='Save '+money(was-now);
        if(!tag){ tag=document.createElement('span'); tag.className='mlyn-pc-save-js'; sale.insertAdjacentElement('afterend',tag); }
        if(tag.textContent!==txt) tag.textContent=txt;
      });
    }
    var pend=0; function runTags(){ if(pend) return; pend=setTimeout(function(){ pend=0; saveTags(); },250); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runTags); else runTags();
    if ('MutationObserver' in window) new MutationObserver(runTags).observe(document.body,{childList:true,subtree:true});
    function run() { document.querySelectorAll('[data-mlyn-facts]').forEach(fillFacts); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();

    /* 10 price per serve on cards and the product page */
    function perServe(){
      document.querySelectorAll('.mlyn-card').forEach(function(card){
        if(card.querySelector('.mlyn-pps')) return;
        var name=card.querySelector('.mlyn-name'); var now=card.querySelector('.mlyn-pc-now'); var box=card.querySelector('.mlyn-price-clean');
        if(!name||!now||!box) return;
        var m=(name.textContent||'').match(/(\d{2,3})\s*(?:serves?|servings?|servs?)\b/i); if(!m) return;
        var n=parseInt(m[1],10); var pr=parse(now.textContent); if(!n||!pr||n<5) return;
        var el=document.createElement('span'); el.className='mlyn-pps'; el.textContent='$'+(pr/n).toFixed(2)+' per serve'; box.appendChild(el);
      });
      var h1=document.querySelector('.product__title, h1'); var cp=document.querySelector('.price-row .current-price');
      if(h1&&cp&&!document.querySelector('.mlyn-pps-pdp')){
        var m2=(h1.textContent||'').match(/(\d{2,3})\s*(?:serves?|servings?|servs?)\b/i); var pr2=parse(cp.textContent);
        if(m2&&pr2&&parseInt(m2[1],10)>=5){ var e2=document.createElement('span'); e2.className='mlyn-pps-pdp'; e2.textContent='$'+(pr2/parseInt(m2[1],10)).toFixed(2)+' per serve'; cp.insertAdjacentElement('afterend',e2); }
      }
    }

    /* 11 pairs well with: one-click add-on from Shopify's own recommendations */
    function pairs(){
      var box=document.querySelector('[data-mlyn-pairs]:not([data-done])'); if(!box) return;
      document.querySelectorAll('[data-mlyn-pairs]').forEach(function(b){ b.dataset.done='1'; });
      var id=box.dataset.productId, root=(box.dataset.root||'/').replace(/\/$/,'');
      function load(intent){ return fetch(root+'/recommendations/products.json?product_id='+id+'&limit=6&intent='+intent).then(function(r){return r.ok?r.json():{products:[]}}).catch(function(){return {products:[]}}); }
      load('complementary').then(function(d){ if(d.products&&d.products.length) return d; return load('related'); }).then(function(d){
        var mine=parseInt(box.dataset.price||'0',10)/100; var cap=Math.max(mine*2.2,70);
        var ok=(d.products||[]).filter(function(x){ return x.available && x.variants && x.variants.some(function(v){return v.available}) && !/twin|pack|bundle|stack|triple|x2|x3/i.test(x.title); });
        var p=ok.filter(function(x){ return (x.price/100)<=cap; }).sort(function(a,b){ return Math.abs(a.price/100-mine)-Math.abs(b.price/100-mine); })[0] || ok.sort(function(a,b){return a.price-b.price})[0]; if(!p) return;
        var v=p.variants.filter(function(v){return v.available})[0];
        var img=(p.featured_image||p.images&&p.images[0]||''); if(img&&img.indexOf('//')===0) img='https:'+img;
        var price=(v.price/100), cmp=(v.compare_at_price||0)/100;
        document.querySelectorAll('[data-mlyn-pairs]').forEach(function(b){
          var body=b.querySelector('.mlyn-pairs-body'); if(!body) return;
          body.innerHTML='<div class="mlyn-pairs-item"><img src="'+(img?img.replace(/(\.[a-z]+)(\?|$)/,'_120x120$1$2'):'')+'" alt="" loading="lazy"><div class="mlyn-pairs-txt"><a href="'+p.url+'">'+p.title.replace(/</g,'&lt;')+'</a><small>Add for <b>'+money(price)+'</b>'+(cmp>price?' <s>'+money(cmp)+'</s>':'')+'</small></div><button type="button" class="mlyn-pairs-btn" data-vid="'+v.id+'">Add</button></div>';
          b.removeAttribute('hidden');
          b.querySelector('.mlyn-pairs-btn').addEventListener('click',function(){
            var btn=this; btn.disabled=true; btn.textContent='Adding';
            fetch(root+'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(btn.dataset.vid,10),quantity:1}]})})
            .then(function(r){ if(!r.ok) throw 0; return r.json(); })
            .then(function(){
              btn.textContent='Added';
              document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
              fetch(root+'/cart.js').then(function(r){return r.json()}).then(function(cart){
                document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cart}}));
                document.dispatchEvent(new CustomEvent('cart-updated',{detail:{cart:cart}}));
                var dr=document.querySelector('cart-drawer')||document.getElementById('CartDrawer');
                if(dr&&typeof dr.open==='function') dr.open();
              });
              setTimeout(function(){ btn.disabled=false; btn.textContent='Add'; },2500);
            }).catch(function(){ btn.disabled=false; btn.textContent='Add'; });
          });
        });
      });
    }
    function runExtras(){ perServe(); pairs(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runExtras); else runExtras();
    if ('MutationObserver' in window) { var pend2=0; new MutationObserver(function(){ if(pend2) return; pend2=setTimeout(function(){ pend2=0; perServe(); },400); }).observe(document.body,{childList:true,subtree:true}); }

    /* 13 macro strip: protein / fat / carbs per serve from the description text */
    function macros(){
      var box=document.querySelector('[data-mlyn-facts]'); if(!box||box.dataset.macros) return; box.dataset.macros='1';
      var t=(box.getAttribute('data-text')||'').replace(/\s+/g,' ');
      function g(re){ var m=t.match(re); return m?m[1]:null; }
      var pro=g(/(?:^|[^\d.])(\d{1,3}(?:\.\d)?)\s?g(?:rams)?\s(?:of\s)?(?:premium\s|whey\s|high[- ]quality\s|pure\s)?protein/i);
      var fat=g(/(?:^|[^\d.])(\d{1,2}(?:\.\d)?)\s?g\s(?:of\s)?(?:total\s)?fat/i);
      var carb=g(/(?:^|[^\d.])(\d{1,3}(?:\.\d)?)\s?g\s(?:of\s)?(?:total\s|net\s)?carb(?:ohydrate)?s?/i);
      var cal=g(/(?:^|[^\d.])(\d{2,4})\s?(?:calories|kcal|cal)\b/i);
      var items=[]; if(pro) items.push([pro+'g','protein']); if(carb) items.push([carb+'g','carbs']); if(fat) items.push([fat+'g','fat']); if(cal) items.push([cal,'calories']);
      if(items.length<2||!pro) return;
      var el=document.createElement('div'); el.className='mlyn-macros';
      el.innerHTML=items.slice(0,4).map(function(i){return '<div class="mlyn-macro"><b>'+i[0]+'</b><span>'+i[1]+'</span></div>';}).join('');
      document.querySelectorAll('[data-mlyn-facts]').forEach(function(b){ var c=el.cloneNode(true); b.insertAdjacentElement('beforebegin',c); var n=document.createElement('small'); n.className='mlyn-macros-note'; n.textContent='Per serve, from the label'; c.insertAdjacentElement('afterend',n);
        b.querySelectorAll('.mlyn-fact').forEach(function(f){ if(/protein per serve|calories per serve/i.test(f.textContent)) f.remove(); });
        if(!b.children.length) b.setAttribute('hidden',''); });
    }

    /* 14 click and collect picker: remember the store, show today's hours, link to the store page */
    function pickup(){
      var sels=document.querySelectorAll('[data-mlyn-pickup-select]'); if(!sels.length) return;
      var saved=null; try{ saved=localStorage.getItem('mlyn_store'); }catch(e){}
      function apply(sel){
        var box=sel.closest('[data-mlyn-pickup]'); var info=box.querySelector('[data-mlyn-pickup-info]'); var opt=sel.options[sel.selectedIndex];
        if(!opt||!opt.value){ info.hidden=true; return; }
        var d=new Date().getDay(), we=(d===0||d===6); var o=we?opt.dataset.wopen:opt.dataset.open, c=we?opt.dataset.wclose:opt.dataset.close;
        var now=new Date(); var hm=now.getHours()*60+now.getMinutes(); function m(s){var p=(s||'').split(':'); return parseInt(p[0]||0,10)*60+parseInt(p[1]||0,10);}
        var open=hm>=m(o)&&hm<m(c);
        box.querySelector('[data-mlyn-pickup-hours]').innerHTML=(open?'<span class="is-open">Open now</span> until '+c:'Opens '+o)+' today · '+(opt.dataset.city||'');
        box.querySelector('[data-mlyn-pickup-link]').href='/pages/store-location/'+opt.value; info.hidden=false;
      }
      sels.forEach(function(sel){
        if(saved){ sel.value=saved; }
        apply(sel);
        sel.addEventListener('change',function(){ try{ localStorage.setItem('mlyn_store',sel.value); }catch(e){} sels.forEach(function(s2){ if(s2!==sel) s2.value=sel.value; apply(s2); }); });
      });
    }
    function runExtras2(){ macros(); pickup(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runExtras2); else runExtras2();
  })();
} catch (e) { if (window.console) console.warn("s247-fx mlyn-ui-pro", e); }

/* ---- from snippets/mlyn-hover-fx.liquid ---- */
try {
(function () {
    var d = document;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var lastCard = null, lastAt = 0;
    function replay(el, cls, ms) { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); setTimeout(function () { el.classList.remove(cls); }, ms); }
    d.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      try {
        var heart = t.closest('.mlyn-badge-card');
        if (heart && !reduce) replay(heart, 'mlyn-heart-pop', 700);
        var q = t.closest('.qty-btn');
        if (q && !reduce) {
          var inp = q.parentElement && q.parentElement.querySelector('.qty-input');
          if (inp && inp.animate) setTimeout(function () {
            inp.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.2)', color: '#1f8bca' }, { transform: 'scale(1)' }], { duration: 260, easing: 'ease-out' });
          }, 0);
        }
        var b = t.closest('.mlyn-product-card button');
        if (b) {
          var row = !!b.closest('[x-show="variantDropdownOpen"]');
          var direct = b.classList.contains('add-to-cart') && !/pick/i.test(b.textContent || '');
          if (row || direct) { lastCard = b.closest('.mlyn-product-card'); lastAt = Date.now(); }
        }
      } catch (err) {}
    }, true);
    d.addEventListener('eurus:cart:items-changed', function () {
      try {
        if (!lastCard || Date.now() - lastAt > 10000) return;
        var btn = lastCard.querySelector('button.add-to-cart');
        lastCard = null;
        if (btn) replay(btn, 'mlyn-card-added', 2300);
      } catch (err) {}
    });
  })();
} catch (e) { if (window.console) console.warn("s247-fx mlyn-hover-fx", e); }

/* ---- from snippets/mlyn-help-center.liquid ---- */
try {
(function () {
    var d = document, w = window;
    var launch = d.querySelector('.s247h-launch'), panel = d.getElementById('s247h-panel');
    if (!launch || !panel) return;
    var body = panel.querySelector('.s247h-body'), form = panel.querySelector('.s247h-form'), input = form.querySelector('input');
    var data = null, feedCache = {}, flow = null;
    var ICONS = {
      box: '<path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/>',
      alert: '<circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5"/><path d="M12 16.5h.01"/>',
      'return': '<path d="M9 14L4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/>',
      store: '<path d="M3 9l1.5-5h15L21 9"/><path d="M4 9v11h16V9"/><path d="M3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0"/><path d="M10 20v-5h4v5"/>',
      chat: '<path d="M21 12a8.5 8.5 0 0 1-12.4 7.6L3 21l1.5-5.2A8.5 8.5 0 1 1 21 12z"/><path d="M8 12h.01M12 12h.01M16 12h.01"/>',
      truck: '<path d="M2 6h12v10H2z"/><path d="M14 10h4l4 4v2h-8"/><circle cx="6.5" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/>',
      bag: '<path d="M5 8h14l-1 12H6L5 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
      tag: '<path d="M3 12V4h8l10 10-8 8L3 12z"/><circle cx="7.5" cy="8.5" r="1.3"/>',
      card: '<rect x="2.5" y="5" width="19" height="14" rx="2"/><path d="M2.5 10h19"/>',
      pin: '<path d="M12 21s7-6.2 7-11.5A7 7 0 0 0 5 9.5C5 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>',
      star: '<path d="M12 3l2.8 5.7 6.2.9-4.5 4.4 1 6.2L12 17.3 6.5 20.2l1-6.2L3 9.6l6.2-.9L12 3z"/>',
      mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 6l8.5 7 8.5-7"/>',
      dumbbell: '<path d="M6.5 6.5v11M17.5 6.5v11M3.5 9v6M20.5 9v6M6.5 12h11"/>',
      bolt: '<path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z"/>',
      compass: '<circle cx="12" cy="12" r="9"/><path d="M15.5 8.5l-2 5-5 2 2-5 5-2z"/>',
      heart: '<path d="M20.8 8.6a5 5 0 0 0-8.8-3.2 5 5 0 0 0-8.8 3.2c0 5.4 8.8 10.9 8.8 10.9s8.8-5.5 8.8-10.9z"/>'
    };
    function svg(n) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + (ICONS[n] || ICONS.chat) + '</svg>'; }
    var CHEV = '<svg class="s247h-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
    var BACK = '<button type="button" class="s247h-back" data-s247h-home><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>All topics</button>';
    var CHATBTN = '<button type="button" class="s247h-btn is-chat" data-s247h-chat>' + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a8.5 8.5 0 0 1-12.4 7.6L3 21l1.5-5.2A8.5 8.5 0 1 1 21 12z"/></svg><span>Text our team</span></button>';
    var LOAD = '<div class="s247h-load" aria-label="Loading"><i></i><i></i><i></i></div>';
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function load() { if (!data) { try { data = JSON.parse(d.getElementById('s247h-data').textContent); } catch (e) { data = { main: [], orderhelp: [], popular: [], finders: {}, topics: {} }; } } return data; }
    function item(id) { var dt = load(); return id.indexOf('f:') === 0 ? dt.finders[id.slice(2)] : dt.topics[id]; }
    function row(id) {
      var t = item(id); if (!t) return '';
      return '<li><button type="button" class="s247h-row" data-go="' + id + '"><span class="s247h-ri">' + svg(t.icon) + '</span><span class="s247h-rt"><b>' + esc(t.title) + '</b><span>' + esc(t.sub || '') + '</span></span>' + CHEV + '</button></li>';
    }
    function show(html) { body.innerHTML = html; body.scrollTop = 0; }
    function money(n) { n = Number(n) || 0; return '$' + n.toFixed(2); }
    function home() {
      var dt = load(); flow = null;
      show('<div class="s247h-hi"><h2>Hi there 👋<span>How can we help?</span></h2><p>Search our full range for live prices and what\'s in stock online, find the right protein or pre-workout, or text our team.</p></div>' +
        '<div class="s247h-card"><ul class="s247h-list">' + dt.main.map(row).join('') + '</ul></div>' +
        '<div class="s247h-card"><h3>Order help</h3><ul class="s247h-list">' + dt.orderhelp.map(row).join('') + '</ul></div>' +
        '<div class="s247h-card"><h3>Popular topics</h3><div class="s247h-chips">' + dt.popular.map(function (id) {
          var t = dt.topics[id]; return t ? '<button type="button" class="s247h-chip" data-go="' + id + '">' + esc(t.title) + '</button>' : '';
        }).join('') + '</div></div>');
    }
    function topic(id) {
      var t = load().topics[id]; if (!t) return home();
      if (t.chat) return openChat();
      var acts = (t.links || []).map(function (l) {
        if (l.chat) return CHATBTN;
        return '<a class="s247h-btn" href="' + esc(l.href) + '"' + (l.external ? ' target="_blank" rel="noopener"' : '') + '>' + esc(l.label) + '</a>';
      }).join('');
      show('<div class="s247h-card s247h-pane">' + BACK + '<h4>' + esc(t.title) + '</h4><div class="s247h-ans">' + (t.answer || '') + '</div>' + (acts ? '<div class="s247h-acts">' + acts + '</div>' : '') + '</div>');
    }
    function prodCard(p) {
      var price = (p.pmax && p.pmax > p.pmin) ? 'From ' + money(p.pmin) : money(p.pmin);
      var img = p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="56" height="56">' : '<span class="s247h-ph"></span>';
      return '<a class="s247h-prod" href="' + esc(p.u) + '">' + img + '<span class="s247h-pt">' + (p.v ? '<small>' + esc(p.v) + '</small>' : '') + '<b>' + esc(p.t) + '</b>' +
        '<span class="s247h-pp">' + price + '<span class="s247h-st' + (p.a ? '' : ' is-out') + '">' + (p.a ? 'In stock online' : 'Out of stock online') + '</span></span></span></a>';
    }
    function feed(handle) {
      if (feedCache[handle]) return Promise.resolve(feedCache[handle]);
      return fetch('/collections/' + encodeURIComponent(handle) + '?sort_by=best-selling&section_id=mlyn-help-feed', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('feed'); return r.text(); })
        .then(function (html) {
          var m = html.match(/<script type="application\/json" data-mlyn-help-feed>([\s\S]*?)<\/script>/);
          var list = m ? JSON.parse(m[1]) : [];
          feedCache[handle] = list; return list;
        });
    }
    function finder(key, step, picks) {
      var f = load().finders[key]; if (!f) return home();
      picks = picks || [];
      if (f.c) return results(f, { c: f.c, name: f.name }, null);
      var s = f.steps[step];
      if (!s) return results(f, picks[0], picks[1] || null);
      flow = { key: key, step: step, picks: picks };
      show('<div class="s247h-card s247h-pane">' + BACK + '<h4>' + esc(f.title) + '</h4>' +
        (f.steps.length > 1 ? '<p class="s247h-step">Step ' + (step + 1) + ' of ' + f.steps.length + '</p>' : '') +
        '<p class="s247h-note" style="font-size:14px;color:#0f172a;font-weight:600">' + esc(s.q) + '</p><div class="s247h-opts">' +
        s.options.map(function (o, i) { return '<button type="button" class="s247h-opt" data-opt="' + i + '"><span><b>' + esc(o.label) + '</b>' + (o.sub ? '<span>' + esc(o.sub) + '</span>' : '') + '</span>' + CHEV + '</button>'; }).join('') +
        '</div></div>');
    }
    function results(f, goal, budget) {
      flow = null;
      var title = goal.name + (budget && budget.max < 99999 ? ', ' + budget.label.toLowerCase() : '');
      show('<div class="s247h-card s247h-pane">' + BACK + '<h4>Our top picks: ' + esc(title) + '</h4><p class="s247h-note">Best sellers first. Prices and stock are live from our online store.</p>' + LOAD + '</div>');
      var ex = goal.x ? [].concat(goal.x) : [], jobs = [feed(goal.c)].concat(ex.map(feed));
      Promise.all(jobs).then(function (res) {
        var list = res[0], skip = {};
        res.slice(1).forEach(function (l) { l.forEach(function (p) { skip[p.u] = 1; }); });
        list = list.filter(function (p) { return !skip[p.u]; });
        if (budget) list = list.filter(function (p) { return p.pmin >= budget.min && p.pmin <= budget.max; });
        list.sort(function (a, b) { return (b.a ? 1 : 0) - (a.a ? 1 : 0); });
        var top = list.slice(0, 4);
        var pane = body.querySelector('.s247h-pane'); if (!pane) return;
        pane.querySelector('.s247h-load').outerHTML = top.length
          ? '<div class="s247h-prods">' + top.map(prodCard).join('') + '</div><a class="s247h-more" href="/collections/' + esc(goal.c) + '">See all ' + esc(goal.name.toLowerCase()) + '</a><div class="s247h-acts">' + CHATBTN.replace('Text our team', 'Not sure? Text our team') + '</div>'
          : '<p class="s247h-ans">Nothing in that range right now. Try another budget, or text our team and we\'ll suggest something.</p><a class="s247h-more" href="/collections/' + esc(goal.c) + '">See all ' + esc(goal.name.toLowerCase()) + '</a><div class="s247h-acts">' + CHATBTN + '</div>';
      }).catch(function () {
        var pane = body.querySelector('.s247h-pane'); if (!pane) return;
        var l = pane.querySelector('.s247h-load'); if (l) l.outerHTML = '<a class="s247h-btn" href="/collections/' + esc(goal.c) + '">See ' + esc(goal.name.toLowerCase()) + '</a>';
      });
    }
    function matchTopics(q) {
      var dt = load(), words = q.toLowerCase().split(/\s+/).filter(function (x) { return x.length > 1; }), hits = [];
      var all = Object.keys(dt.topics).concat(Object.keys(dt.finders).map(function (k) { return 'f:' + k; }));
      all.forEach(function (id) {
        var t = item(id), hay = (t.title + ' ' + (t.sub || '') + ' ' + (t.keys || '')).toLowerCase(), score = 0;
        words.forEach(function (wd) { if (hay.indexOf(wd) > -1) score += (t.title.toLowerCase().indexOf(wd) > -1 ? 3 : 1); });
        if (score) hits.push([score, id]);
      });
      hits.sort(function (a, b) { return b[0] - a[0]; });
      return hits.slice(0, 3).map(function (h) { return h[1]; });
    }
    var seq = 0;
    function ask(q) {
      q = q.trim(); if (q.length < 2) return;
      var my = ++seq, tops = matchTopics(q), orderish = /\b(order|track|tracking|parcel|delivery|arrived|refund|return|#?\d{4,})\b/i.test(q);
      show('<div class="s247h-q"><span>' + esc(q) + '</span></div><div class="s247h-card s247h-pane">' + BACK +
        (tops.length ? '<p class="s247h-sub" style="margin-top:0">Help topics</p><div class="s247h-card" style="margin-top:0"><ul class="s247h-list">' + tops.map(row).join('') + '</ul></div>' : '') +
        '<p class="s247h-sub">Products</p><div class="s247h-res">' + LOAD + '</div></div>');
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
        if (my !== seq) return;
        var ps = (((j || {}).resources || {}).results || {}).products || [];
        var box = body.querySelector('.s247h-res'); if (!box) return;
        var list = ps.map(function (p) {
          var v = String(p.vendor || ''), vl = v.toLowerCase();
          return { t: p.title, u: String(p.url || '').split('?')[0], i: p.image ? p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '', v: (vl === 'unknown' || vl === 'not specified') ? '' : v,
            pmin: parseFloat(p.price_min || p.price) || 0, pmax: parseFloat(p.price_max || p.price) || 0, a: p.available === true || p.available === 'true' };
        });
        box.innerHTML = list.length
          ? '<div class="s247h-prods">' + list.slice(0, 5).map(prodCard).join('') + '</div><a class="s247h-more" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results</a>'
          : '<p class="s247h-ans">' + (orderish ? 'For order questions, open <b>Track my order</b> above or text our team with your order number.' : 'No products found for that. Try a brand or product name, or text our team.') + '</p>';
        box.insertAdjacentHTML('beforeend', '<div class="s247h-acts">' + CHATBTN + '</div>');
      }).catch(function () {
        var box = body.querySelector('.s247h-res'); if (box) box.innerHTML = '<a class="s247h-btn" href="/search?q=' + encodeURIComponent(q) + '">Search the store for "' + esc(q) + '"</a><div class="s247h-acts">' + CHATBTN + '</div>';
      });
    }
    function setOpen(on) {
      if (on) { home(); input.value = ''; panel.hidden = false; launch.setAttribute('aria-expanded', 'true'); launch.setAttribute('aria-label', 'Close help');
        if (w.matchMedia('(min-width: 768px)').matches) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, 60); }
      else { panel.hidden = true; launch.setAttribute('aria-expanded', 'false'); launch.removeAttribute('aria-label'); }
    }
    function openChat() {
      var labels = panel.querySelectorAll('.s247h-btn[data-s247h-chat] span');
      if (w.PodiumWebChat && typeof w.PodiumWebChat.open === 'function') { setOpen(false); w.PodiumWebChat.open(); return; }
      labels.forEach(function (s) { s.textContent = 'Opening chat...'; });
      if (!d.getElementById('podium-widget')) {
        var s = d.createElement('script');
        s.src = 'https://connect.podium.com/widget.js#ORG_TOKEN=c1399a14-38e1-495c-a523-942f538454b0';
        s.id = 'podium-widget'; s.defer = true;
        s.setAttribute('data-organization-api-token', 'c1399a14-38e1-495c-a523-942f538454b0');
        d.body.appendChild(s);
      }
      var t0 = Date.now();
      (function wait() {
        if (w.PodiumWebChat && typeof w.PodiumWebChat.open === 'function') { setOpen(false); w.PodiumWebChat.open(); return; }
        if (Date.now() - t0 > 8000) { w.location.href = '/pages/contact-us'; return; }
        setTimeout(wait, 200);
      })();
    }
    launch.addEventListener('click', function () { setOpen(panel.hidden); });
    panel.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      if (t.closest('.s247h-x')) { setOpen(false); launch.focus(); return; }
      if (t.closest('[data-s247h-chat]')) { openChat(); return; }
      if (t.closest('[data-s247h-home]')) { home(); return; }
      var op = t.closest('[data-opt]');
      if (op && flow) { var f = load().finders[flow.key], o = f.steps[flow.step].options[+op.getAttribute('data-opt')]; return finder(flow.key, flow.step + 1, flow.picks.concat([o])); }
      var go = t.closest('[data-go]');
      if (go) { var id = go.getAttribute('data-go'); if (id.indexOf('f:') === 0) finder(id.slice(2), 0, []); else topic(id); }
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); ask(input.value); input.value = ''; });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { setOpen(false); launch.focus(); } });
    d.addEventListener('click', function (e) {
      if (panel.hidden) return;
      var path = e.composedPath ? e.composedPath() : [];
      if (path.indexOf(panel) > -1 || path.indexOf(launch) > -1 || panel.contains(e.target) || launch.contains(e.target)) return;
      setOpen(false);
    });
    /* keep the button above any bar fixed to the bottom of the screen (sticky Add to cart, upsell bars) */
    var tick = 0;
    function lift() {
      tick = 0;
      var off = 0, ih = w.innerHeight, iw = w.innerWidth;
      try {
        var els = d.elementsFromPoint ? d.elementsFromPoint(iw - 30, ih - 6) : [];
        for (var i = 0; i < els.length; i++) {
          var n = els[i];
          if (launch.contains(n) || panel.contains(n) || n === d.documentElement || n === d.body) continue;
          while (n && n !== d.body) {
            var cs = w.getComputedStyle(n);
            if (cs.position === 'fixed' || cs.position === 'sticky') {
              var r = n.getBoundingClientRect();
              if (r.width > iw * 0.5 && r.bottom >= ih - 2 && r.height > 0 && r.height < ih * 0.4) off = Math.max(off, Math.round(ih - r.top));
              break;
            }
            n = n.parentElement;
          }
        }
      } catch (e) {}
      /* 10 Oct 2026: also sit above sticky bars marked data-s247-lift (Build your stack total bar) */
      try { d.querySelectorAll('[data-s247-lift]').forEach(function (el) { var r = el.getBoundingClientRect();
        if (r.height && r.top < ih && r.bottom > ih - 200 && r.right > iw - 90) off = Math.max(off, Math.round(ih - r.top) + 8); }); } catch (e) {}
      launch.style.setProperty('--s247h-off', off + 'px'); panel.style.setProperty('--s247h-off', off + 'px'); if (w.__s247Lift !== off) { w.__s247Lift = off; d.documentElement.style.setProperty('--s247-lift', off + 'px'); }
    }
    /* 10 Oct 2026 speed: check once scrolling pauses (not on every frame), and every 3s only while the tab is visible */
    var liftT = 0; function soon() { clearTimeout(liftT); liftT = setTimeout(function () { if (!tick) tick = requestAnimationFrame(lift); }, 140); }
    w.addEventListener('scroll', soon, { passive: true });
    w.addEventListener('resize', soon);
    setTimeout(lift, 800); setInterval(function () { if (!d.hidden && !tick) tick = requestAnimationFrame(lift); }, 3000);
  })();
} catch (e) { if (window.console) console.warn("s247-fx mlyn-help-center", e); }

try {
/* 10 Oct 2026: phone bottom bar, scroll story and Build your stack. Plain JS, no libraries. */
(function () {
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function money(c) {
    var n = (Math.round(c) / 100).toFixed(2).split('.');
    return '$' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
  }
  function root() { return (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/'; }
  function getCart() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); });
  }
  /* open the cart drawer the site already uses (the theme drawer that the header cart icon opens; then the Slide Cart app; then the cart page) */
  function openCart(refresh) {
    try {
      var st = w.Alpine && w.Alpine.store && w.Alpine.store('xMiniCart');
      if (st && typeof st.openCart === 'function') {
        if (refresh && typeof st.reLoad === 'function') st.reLoad();
        st.openCart();
        return;
      }
    } catch (e) {}
    try {
      if (typeof w.SLIDECART_OPEN === 'function') {
        if (refresh && typeof w.SLIDECART_UPDATE === 'function') w.SLIDECART_UPDATE();
        w.SLIDECART_OPEN();
        return;
      }
    } catch (e) {}
    w.location.href = root() + 'cart';
  }

  /* 1. bottom bar on phones */
  try {
    var bn = d.querySelector('.s247-bn');
    if (bn) {
      var badge = bn.querySelector('[data-s247bn-count]');
      var setCount = function (n) {
        if (!badge) return;
        var old = parseInt(badge.textContent, 10) || 0;
        badge.textContent = n;
        badge.hidden = !(n > 0);
        if (n > old && !reduce) { badge.classList.remove('is-bump'); void badge.offsetWidth; badge.classList.add('is-bump'); }
      };
      var pend = 0;
      var refresh = function () {
        if (pend) return;
        pend = setTimeout(function () { pend = 0; getCart().then(function (c) { setCount(c.item_count); }).catch(function () {}); }, 350);
      };
      /* watch cart changes made anywhere on the page without touching the theme's own code */
      if ('PerformanceObserver' in w) {
        try {
          new PerformanceObserver(function (list) {
            list.getEntries().forEach(function (e) {
              if (/\/cart\/(add|change|update|clear)/.test(e.name)) refresh();
            });
          }).observe({ type: 'resource', buffered: false });
        } catch (e) {}
      }
      d.addEventListener('cart:updated', refresh);
      w.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

      bn.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('[data-s247bn]');
        if (!a) return;
        var k = a.getAttribute('data-s247bn');
        if (k === 'cart') {
          e.preventDefault();
          openCart(true);
        } else if (k === 'shop') {
          var tg = d.querySelector('.mlyn-drawer-toggle');
          if (tg && tg.getClientRects().length) { e.preventDefault(); tg.click(); }
        } else if (k === 'search') {
          var ins = d.querySelectorAll('.mlyn-search-input, input[type="search"][name="q"]'), inp = null;
          for (var i = 0; i < ins.length; i++) { if (ins[i].getClientRects().length) { inp = ins[i]; break; } }
          if (inp) {
            e.preventDefault();
            w.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
            setTimeout(function () { try { inp.focus({ preventScroll: true }); } catch (x) { inp.focus(); } }, reduce ? 0 : 320);
          }
        }
      });
    }
  } catch (e) {}

  /* 2. scroll story: facts slide in one by one, numbers count up, the photo eases as you scroll */
  try {
    d.querySelectorAll('[data-s247ss]').forEach(function (sec) {
      if (reduce || !('IntersectionObserver' in w)) return;
      sec.classList.add('is-ready');
      var count = function (el) {
        var raw = (el.getAttribute('data-count') || '').trim();
        if (!/^\d{1,4}$/.test(raw)) return;
        var to = parseInt(raw, 10), t0 = 0, dur = 900;
        if (to < 2) return;
        var step = function (t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(to * e);
          if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
        };
        el.textContent = '0';
        requestAnimationFrame(step);
      };
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          var c = en.target.querySelector('[data-count]');
          if (c) count(c);
          io.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -14% 0px' });
      sec.querySelectorAll('.s247ss__fact').forEach(function (f) { io.observe(f); });

      /* scroll-linked value only while the section is on screen */
      var on = false, tk = 0;
      var upd = function () {
        tk = 0;
        var r = sec.getBoundingClientRect(), vh = w.innerHeight || 800;
        var p = (vh - r.top) / (vh + r.height);
        p = p < 0 ? 0 : p > 1 ? 1 : p;
        sec.style.setProperty('--p', p.toFixed(3));
      };
      var onScroll = function () { if (on && !tk) tk = requestAnimationFrame(upd); };
      new IntersectionObserver(function (ents) {
        on = ents[0].isIntersecting;
        if (on) upd();
      }).observe(sec);
      w.addEventListener('scroll', onScroll, { passive: true });
    });
  } catch (e) {}

  /* 3. Build your stack */
  try {
    d.querySelectorAll('[data-s247stk]').forEach(function (box) {
      var free = parseInt(box.getAttribute('data-free'), 10) || 0;
      var cartTotal = parseInt(box.getAttribute('data-cart'), 10) || 0;
      var goals = [].slice.call(box.querySelectorAll('[data-goal]'));
      var plans = [].slice.call(box.querySelectorAll('[data-plan]'));
      var elCount = box.querySelector('[data-count]'), elTotal = box.querySelector('[data-total]');
      var elShip = box.querySelector('[data-ship]'), btn = box.querySelector('[data-add]');
      var msgTimer = 0;

      function plan() { for (var i = 0; i < plans.length; i++) if (!plans[i].hidden) return plans[i]; return plans[0]; }
      function varOf(card) {
        var v = card.querySelector('[data-var]');
        if (!v) return null;
        if (v.tagName === 'SELECT') {
          var o = v.options[v.selectedIndex];
          return o ? { id: o.value, price: parseInt(o.getAttribute('data-price'), 10) || 0 } : null;
        }
        return { id: v.value, price: parseInt(v.getAttribute('data-price'), 10) || 0 };
      }
      function picks() {
        var out = [], p = plan();
        if (!p) return out;
        p.querySelectorAll('[data-slot]').forEach(function (slot) {
          var r = slot.querySelector('[data-pick]:checked');
          if (!r || r.hasAttribute('data-skip')) return;
          var v = varOf(r.closest('.s247stk__card'));
          if (v && v.id) out.push(v);
        });
        return out;
      }
      function calc() {
        var list = picks(), sum = 0;
        list.forEach(function (v) { sum += v.price; });
        if (elCount) elCount.textContent = list.length + (list.length === 1 ? ' item' : ' items');
        if (elTotal) elTotal.textContent = money(sum);
        if (btn) { btn.disabled = !list.length; if (!btn.classList.contains('is-busy') && !btn.classList.contains('is-done')) btn.textContent = list.length ? 'Add stack to cart' : 'Pick at least one'; }
        if (elShip && free > 0 && !msgTimer) {
          var left = free - (cartTotal + sum);
          elShip.classList.toggle('is-free', left <= 0);
          elShip.textContent = left <= 0 ? 'Free shipping unlocked' : money(left) + ' more for free shipping';
        }
      }
      function setGoal(g) {
        goals.forEach(function (b) {
          var on = b === g;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
        });
        var id = g.getAttribute('data-goal');
        plans.forEach(function (p) { p.hidden = p.getAttribute('data-plan') !== id; });
        btn && btn.classList.remove('is-done');
        calc();
      }
      goals.forEach(function (b, i) {
        b.tabIndex = b.classList.contains('is-on') ? 0 : -1;
        b.addEventListener('click', function () { setGoal(b); });
        b.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowRight' || k === 'ArrowDown') n = goals[(i + 1) % goals.length];
          if (k === 'ArrowLeft' || k === 'ArrowUp') n = goals[(i - 1 + goals.length) % goals.length];
          if (n) { e.preventDefault(); setGoal(n); n.focus(); }
        });
      });

      box.addEventListener('change', function (e) {
        var t = e.target;
        if (t.matches && t.matches('select[data-var]')) {
          var card = t.closest('.s247stk__card');
          var o = t.options[t.selectedIndex], lab = card.querySelector('[data-price-label]');
          if (o && lab) lab.textContent = money(parseInt(o.getAttribute('data-price'), 10) || 0);
          var r = card.querySelector('[data-pick]');
          if (r && !r.checked) r.checked = true;
        }
        if (btn) btn.classList.remove('is-done');
        calc();
      });
      /* tapping the flavour menu or the Details link should not fight with the card's radio */
      box.addEventListener('click', function (e) {
        var s = e.target.closest && e.target.closest('select[data-var]');
        if (s) { var r = s.closest('.s247stk__card').querySelector('[data-pick]'); if (r && !r.checked) { r.checked = true; calc(); } }
      });

      function say(txt, ok) {
        if (!elShip) return;
        clearTimeout(msgTimer);
        elShip.textContent = txt;
        elShip.classList.toggle('is-err', !ok);
        msgTimer = setTimeout(function () { msgTimer = 0; elShip.classList.remove('is-err'); calc(); }, 4500);
      }

      btn && btn.addEventListener('click', function () {
        var list = picks();
        if (!list.length || btn.classList.contains('is-busy')) return;
        btn.classList.add('is-busy'); btn.disabled = true; btn.textContent = 'Adding...';
        fetch(root() + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: list.map(function (v) { return { id: parseInt(v.id, 10), quantity: 1 }; }) })
        }).then(function (r) {
          return r.json().then(function (j) { if (!r.ok) throw j; return j; });
        }).then(function () {
          btn.classList.remove('is-busy'); btn.classList.add('is-done'); btn.disabled = false;
          btn.textContent = 'Added to cart';
          return getCart().then(function (c) {
            cartTotal = c.total_price;
            d.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } }));
            calc();
            openCart(true);
          }).catch(function () { openCart(true); });
        }).catch(function (err) {
          btn.classList.remove('is-busy'); btn.disabled = false; btn.textContent = 'Add stack to cart';
          var m = (err && (err.description || err.message)) || 'Sorry, that did not work. Please try again.';
          say(String(m).replace(/<[^>]*>/g, ''), false);
        });
      });

      /* the page can be cached, so read the live cart total once */
      getCart().then(function (c) { cartTotal = c.total_price; calc(); }).catch(function () {});
      /* 10 Oct 2026: links like /pages/build-your-stack?goal=g_lean open with that goal chosen (homepage goal picker) */
      try {
        var want = new URL(w.location.href).searchParams.get('goal');
        if (want) goals.forEach(function (b) { if (b.getAttribute('data-goal') === want) setGoal(b); });
      } catch (e) {}
      calc();
    });
  } catch (e) {}

  /* 4. pointer tilt on computers: hero banner and scroll story photo lean toward the mouse or trackpad pointer */
  try {
    if (!reduce && w.matchMedia && w.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      var tgts = [];
      var hero = d.querySelector('.theme-template-index > [id*="__mlyn_hero_slider"] > *');
      if (hero) tgts.push([hero, 2.2]);
      d.querySelectorAll('.s247ss__stick').forEach(function (el) { tgts.push([el, 7]); });
      tgts.forEach(function (t) {
        var el = t[0], max = t[1], raf = 0, px = 0, py = 0;
        el.setAttribute('data-s247-tilt', '');
        var host = el.closest('.shopify-section') || el;
        host.addEventListener('pointermove', function (e) {
          if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
          px = e.clientX; py = e.clientY;
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = 0;
            var r = el.getBoundingClientRect();
            if (!r.width || !r.height) return;
            var x = Math.max(0, Math.min(1, (px - r.left) / r.width)) - 0.5;
            var y = Math.max(0, Math.min(1, (py - r.top) / r.height)) - 0.5;
            el.classList.add('is-tilting');
            el.style.setProperty('--s247-rx', (x * 2 * max).toFixed(2) + 'deg');
            el.style.setProperty('--s247-ry', (-y * 2 * max).toFixed(2) + 'deg');
          });
        }, { passive: true });
        host.addEventListener('pointerleave', function () {
          el.classList.remove('is-tilting');
          el.style.setProperty('--s247-rx', '0deg');
          el.style.setProperty('--s247-ry', '0deg');
        });
      });
    }
  } catch (e) {}

  /* 5. product page: fold away unavailable flavour or size pills (4 or more) behind a "Show" link */
  try {
    d.querySelectorAll('.variant-pills-container').forEach(function (box) {
      var more = d.createElement('button');
      more.type = 'button'; more.className = 's247-pills-more'; more.hidden = true;
      box.insertAdjacentElement('afterend', more);
      var open = false;
      var upd = function () {
        var un = box.querySelectorAll('.variant-pill.pill-unavailable:not(.pill-selected)').length;
        var all = box.querySelectorAll('.variant-pill').length;
        var on = un >= 4 && all - un >= 1;
        box.classList.toggle('s247-fold', on && !open);
        more.hidden = !on;
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        var txt = open ? 'Hide unavailable options' : 'Show ' + un + ' more (sold out or not in this size)';
        if (more.textContent !== txt) more.textContent = txt;
      };
      more.addEventListener('click', function () { open = !open; upd(); });
      new MutationObserver(function (recs) {
        for (var i = 0; i < recs.length; i++) { if (recs[i].target !== box) { upd(); return; } }
      }).observe(box, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
      upd();
    });
  } catch (e) {}

  /* 6. category filters (brand, price, in stock, type). See snippets/s247-filter-bar.liquid */
  try {
    /* same brand written different ways is shown once (product data is not changed) */
    var ALIAS = { atp: 'atpscience', beastlabs: 'beastlabsnutrition', inspired: 'inspirednutraceuticals', musclesports: 'musclesport', ghostlifestyle: 'ghost' };
    var SKIP = { '': 1, unknown: 1, notspecified: 1, defaultvendor: 1, amazon: 1, supps247: 1, vendor: 1 };
    var norm = function (v) { var k = String(v || '').toLowerCase().replace(/[^a-z0-9]/g, ''); return ALIAS[k] || k; };
    var pretty = function (v) { v = String(v || '').trim(); return v === v.toLowerCase() ? v.replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }) : v; };
    d.querySelectorAll('[data-s247f]').forEach(function (box) {
      var wrap = d.getElementById('product-grid-container');
      if (!wrap) return;
      var bar = box.querySelector('.s247f__bar'), panel = box.querySelector('[data-s247f-panel]');
      var scrim = box.querySelector('[data-s247f-scrim]'), status = box.querySelector('[data-s247f-status]');
      var badge = box.querySelector('[data-s247f-n]'), openBtn = box.querySelector('[data-s247f-open]');
      var showBtn = box.querySelector('[data-s247f-show]'), wait = box.querySelector('[data-s247f-wait]');
      var url = box.getAttribute('data-url'), sort = box.getAttribute('data-sort') || '';
      var original = wrap.innerHTML, gridClass = '';
      var g0 = wrap.querySelector('#product-grid'); if (g0) gridClass = g0.className;
      var st = { brand: [], type: [], price: [], stock: [] };
      var all = null, loading = null, filtered = false;
      var fresh = function () { return { brand: [], type: [], price: [], stock: [] }; };
      var key = function (li, g) { return g === 'brand' ? norm(li.getAttribute('data-s247v')) : norm(li.getAttribute('data-s247t')); };

      function count() { return st.brand.length + st.type.length + st.price.length + st.stock.length; }
      function inPrice(p, band) { var b = band.split('-'), lo = parseInt(b[0], 10) || 0, hi = b[1] === '' ? Infinity : parseInt(b[1], 10); return p >= lo && p < hi; }
      function ok(li, skip) {
        var a = li.getAttribute('data-s247a') === '1', p = parseInt(li.getAttribute('data-s247p'), 10) || 0;
        if (skip !== 'brand' && st.brand.length && st.brand.indexOf(key(li, 'brand')) < 0) return false;
        if (skip !== 'type' && st.type.length && st.type.indexOf(key(li, 'type')) < 0) return false;
        if (skip !== 'stock' && st.stock.length && !a) return false;
        if (skip !== 'price' && st.price.length && !st.price.some(function (b) { return inPrice(p, b); })) return false;
        return true;
      }
      function load() {
        if (all) return Promise.resolve(all);
        if (loading) return loading;
        var get = function (page) {
          var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=s247-all&page=' + page + (sort ? '&sort_by=' + encodeURIComponent(sort) : '');
          return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw 0; return r.text(); })
            .then(function (h) { return new DOMParser().parseFromString(h, 'text/html'); });
        };
        loading = get(1).then(function (doc) {
          var root = doc.getElementById('s247-all'); if (!root) throw 0;
          var pages = Math.min(parseInt(root.getAttribute('data-pages'), 10) || 1, 2);
          var list = [].slice.call(root.querySelectorAll('ul > li'));
          if (pages < 2) return list;
          return get(2).then(function (d2) { var r2 = d2.getElementById('s247-all'); return list.concat(r2 ? [].slice.call(r2.querySelectorAll('ul > li')) : []); });
        }).then(function (list) { all = list; lists(); return all; });
        loading.catch(function () { loading = null; });
        return loading;
      }
      /* brand and type lists for the panel, built from the products actually on sale in this category */
      function lists() {
        ['brand'].forEach(function (g) { /* product types are written too many ways to be useful, so only brands are listed */
          var fs = box.querySelector('[data-s247f-list="' + g + '"]'); if (!fs) return;
          var reg = {};
          all.forEach(function (li) {
            var raw = li.getAttribute(g === 'brand' ? 'data-s247v' : 'data-s247t') || '', k = key(li, g);
            if (SKIP[k]) return;
            var r = reg[k] || (reg[k] = { names: {}, n: 0 }); r.n++; r.names[raw] = (r.names[raw] || 0) + 1;
          });
          var keys = Object.keys(reg);
          if (keys.length < 2 || (g === 'type' && keys.length > 20)) { fs.hidden = true; return; }
          var opts = keys.map(function (k) {
            var names = reg[k].names, best = Object.keys(names).sort(function (a, b) { return names[b] - names[a] || (b !== b.toLowerCase()) - (a !== a.toLowerCase()) || b.length - a.length; })[0];
            return { k: k, label: pretty(best) };
          }).sort(function (a, b) { return a.label.localeCompare(b.label); });
          fs.querySelector('[data-list]').innerHTML = opts.map(function (o) {
            return '<label class="s247f__opt"><input type="checkbox" data-g="' + g + '" data-v="' + o.k + '"><span>' + o.label.replace(/[<&]/g, '') + '</span><em data-c></em></label>';
          }).join('');
          fs.hidden = false;
        });
        if (wait) wait.hidden = true;
        sync();
      }
      function sync() {
        box.querySelectorAll('[data-g][data-v]').forEach(function (el) {
          var on = st[el.getAttribute('data-g')].indexOf(el.getAttribute('data-v')) > -1;
          if (el.tagName === 'INPUT') el.checked = on; else el.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var n = count();
        badge.hidden = !n; badge.textContent = n;
        /* keep the choice when the shopper changes the sort order */
        d.querySelectorAll('#CollectionSection form select[name="sort_by"]').forEach(function (sel) {
          var f = sel.form, h = f.querySelector('input[name="f"]');
          if (!h) { h = d.createElement('input'); h.type = 'hidden'; h.name = 'f'; f.appendChild(h); }
          h.value = enc(); h.disabled = !n;
        });
        try {
          var u = new URL(w.location.href);
          if (n || u.searchParams.has('f')) {
            if (n) { u.searchParams.set('f', enc()); u.searchParams.delete('page'); } else u.searchParams.delete('f');
            w.history.replaceState(w.history.state, '', u.toString());
          }
        } catch (e) {}
      }
      function enc() { return ['brand', 'type', 'price', 'stock'].map(function (g) { return st[g].map(function (v) { return g + ':' + v; }).join('~'); }).filter(Boolean).join('~'); }
      function dec(str) {
        (str || '').split('~').forEach(function (part) {
          var i = part.indexOf(':'); if (i < 1) return;
          var g = part.slice(0, i), v = part.slice(i + 1);
          if (st[g] && v && st[g].indexOf(v) < 0) st[g].push(v);
        });
      }
      function counts() {
        if (!all) return;
        box.querySelectorAll('input[data-g][data-v]').forEach(function (inp) {
          var g = inp.getAttribute('data-g'), v = inp.getAttribute('data-v'), c = 0;
          all.forEach(function (li) {
            if (!ok(li, g)) return;
            if (g === 'brand' || g === 'type') { if (key(li, g) === v) c++; }
            else if (g === 'stock') { if (li.getAttribute('data-s247a') === '1') c++; }
            else if (g === 'price' && inPrice(parseInt(li.getAttribute('data-s247p'), 10) || 0, v)) c++;
          });
          var em = inp.parentNode.querySelector('[data-c]'); if (em) em.textContent = c;
          inp.parentNode.classList.toggle('is-zero', c === 0 && !inp.checked);
        });
        var m = all.filter(function (li) { return ok(li); }).length;
        if (showBtn) showBtn.textContent = count() ? 'Show ' + m + (m === 1 ? ' product' : ' products') : 'Show all ' + all.length + ' products';
      }
      function apply() {
        sync();
        if (!count()) {
          if (filtered) { wrap.innerHTML = original; wrap.style.display = ''; filtered = false; }
          status.hidden = true; counts(); return;
        }
        box.classList.add('is-loading');
        load().then(function (list) {
          box.classList.remove('is-loading');
          var keep = list.filter(function (li) { return ok(li); });
          filtered = true; wrap.style.display = '';
          if (keep.length) {
            wrap.innerHTML = '<ul class="' + (gridClass || 'grid grid-cols-2 lg:grid-cols-4 gap-2 auto-rows-fr') + '" role="list" id="product-grid">' +
              keep.map(function (li) { return li.outerHTML; }).join('') + '</ul>';
          } else {
            wrap.innerHTML = '<div class="s247f__empty"><p>No products match these filters.</p><button type="button" data-s247f-clear>Clear filters</button></div>';
          }
          status.hidden = false;
          status.innerHTML = '<span>Showing <b>' + keep.length + '</b> of ' + list.length + ' products</span> <button type="button" data-s247f-clear>Clear filters</button>';
          counts();
        }).catch(function () {
          box.classList.remove('is-loading');
          status.hidden = false; status.textContent = 'Filters could not load. Please refresh the page.';
        });
      }
      function toggle(g, v) {
        var i = st[g].indexOf(v);
        if (i > -1) st[g].splice(i, 1); else st[g].push(v);
        apply();
      }
      function openPanel(on, focusGroup) {
        panel.hidden = !on; scrim.hidden = !on;
        openBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
        d.documentElement.classList.toggle('s247f-lock', on && w.innerWidth < 768);
        if (on && w.innerWidth >= 768) {
          /* computers: bring the filter bar just under the sticky header so the whole panel is visible */
          var top = box.getBoundingClientRect().top;
          if (top < 170 || top > w.innerHeight * 0.45) w.scrollTo({ top: w.scrollY + top - 170, behavior: reduce ? 'auto' : 'smooth' });
        }
        if (on) {
          load().then(function () {
            counts();
            if (focusGroup) { var fg = box.querySelector('[data-s247f-list="' + focusGroup + '"]'), bd = box.querySelector('.s247f__body'); if (fg && !fg.hidden && bd) bd.scrollTop = fg.offsetTop - bd.offsetTop; }
          }).catch(function () { if (wait) wait.textContent = 'Brands could not load. Please refresh the page.'; });
          var f = panel.querySelector('.s247f__x'); if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 60);
        } else openBtn.focus({ preventScroll: true });
      }
      /* quick brand chips: the brands that appear most on the first page of this category */
      (function () {
        var tally = {}, label = {};
        wrap.querySelectorAll('#product-grid > li[data-s247v]').forEach(function (li) {
          var k = key(li, 'brand'); if (SKIP[k]) return;
          tally[k] = (tally[k] || 0) + 1; if (!label[k] || label[k] === label[k].toLowerCase()) label[k] = li.getAttribute('data-s247v');
        });
        var top = Object.keys(tally).sort(function (a, b) { return tally[b] - tally[a]; });
        if (top.length < 2) return;
        top.slice(0, 6).forEach(function (k) {
          var b = d.createElement('button'); b.type = 'button'; b.className = 's247f__chip is-brand';
          b.setAttribute('data-g', 'brand'); b.setAttribute('data-v', k); b.setAttribute('aria-pressed', 'false');
          b.textContent = pretty(label[k]); bar.appendChild(b);
        });
        var more = d.createElement('button'); more.type = 'button'; more.className = 's247f__chip is-more';
        more.setAttribute('data-s247f-brands', ''); more.textContent = 'All brands'; bar.appendChild(more);
      })();
      bar.addEventListener('click', function (e) {
        if (e.target.closest('[data-s247f-brands]')) { openPanel(true, 'brand'); return; }
        var c = e.target.closest('[data-g][data-v]');
        if (c) toggle(c.getAttribute('data-g'), c.getAttribute('data-v'));
      });
      panel.addEventListener('change', function (e) {
        var t = e.target;
        if (t.matches('input[data-g][data-v]')) toggle(t.getAttribute('data-g'), t.getAttribute('data-v'));
      });
      openBtn.addEventListener('click', function () { openPanel(panel.hidden); });
      scrim.addEventListener('click', function () { openPanel(false); });
      box.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) openPanel(false); });
      d.addEventListener('click', function (e) {
        if (e.target.closest('[data-s247f-clear]') && (box.contains(e.target) || wrap.contains(e.target))) { st = fresh(); apply(); }
      });
      panel.addEventListener('click', function (e) { if (e.target.closest('[data-s247f-close]')) openPanel(false); });
      /* the category search box replaces the grid with its own results: drop the filters quietly */
      d.querySelectorAll('.mlyn-collection-search-input-desktop, .mlyn-collection-search-input-mobile').forEach(function (inp) {
        inp.addEventListener('input', function () {
          if (!count()) return;
          st = fresh(); filtered = false; status.hidden = true; sync();
        });
      });
      /* filters chosen earlier (shared link, back button, sort change) */
      try { dec(new URL(w.location.href).searchParams.get('f')); } catch (e) {}
      if (count()) apply(); else sync();
    });
  } catch (e) {}

  /* 7. homepage goal picker (sections/s247-goal-picker.liquid): a blue pill slides to the chosen goal, the big word
     changes and that goal's products slide in. Each goal's products load once, the first time they are wanted. */
  try {
    d.querySelectorAll('[data-s247gp]').forEach(function (box) {
      var tabsEl = box.querySelector('[data-tabs]'), ind = box.querySelector('[data-ind]');
      var tabs = [].slice.call(box.querySelectorAll('[role="tab"]'));
      var stage = box.querySelector('[role="tabpanel"]'), row = box.querySelector('.s247gp__row'), word = box.querySelector('.s247gp__word');
      var allA = box.querySelector('.s247gp__all'), stackA = box.querySelector('.s247gp__stack');
      var prev = box.querySelector('.s247gp__nav--prev'), next = box.querySelector('.s247gp__nav--next');
      if (!tabs.length || !row || !tabsEl) return;
      var cache = {}, pending = {}, cur = tabs[0], seq = 0, wseq = 0;
      /* products the shop chose to leave out of the goal picker (section setting), by handle */
      var hide = {};
      (box.getAttribute('data-hide') || '').split(',').forEach(function (h) { h = h.trim(); if (h) hide[h] = 1; });
      function tidy() {
        var n = 0;
        [].slice.call(row.querySelectorAll('.mlyn-card')).forEach(function (c) {
          var a = c.querySelector('a[href*="/products/"]'), m = a && /\/products\/([^/?#]+)/.exec(a.getAttribute('href'));
          if ((m && hide[decodeURIComponent(m[1])]) || n >= 10) { c.parentNode && c.parentNode.removeChild(c); return; }
          n++;
        });
        return n;
      }
      var EMPTY = '<p class="s247gp__empty">Nothing in stock here right now. Try another goal.</p>';

      function moveInd(anim) {
        if (!ind || !cur) return;
        if (!anim) ind.style.transition = 'none';
        ind.style.left = cur.offsetLeft + 'px';
        ind.style.width = cur.offsetWidth + 'px';
        if (!anim) { void ind.offsetWidth; ind.style.transition = ''; }
      }
      function keepVisible(t) {
        var l = t.offsetLeft, r = l + t.offsetWidth, sl = tabsEl.scrollLeft, cw = tabsEl.clientWidth;
        if (l < sl + 8 || r > sl + cw - 8) {
          var to = Math.max(0, l - (cw - t.offsetWidth) / 2);
          try { tabsEl.scrollTo({ left: to, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { tabsEl.scrollLeft = to; }
        }
      }
      function load(h) {
        if (!h) return Promise.resolve('');
        if (cache[h] != null) return Promise.resolve(cache[h]);
        if (pending[h]) return pending[h];
        pending[h] = fetch(root() + 'collections/' + encodeURIComponent(h) + '?view=s247-row', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw 0; return r.text(); })
          .then(function (txt) {
            var el = new DOMParser().parseFromString(txt, 'text/html').getElementById('s247-row');
            var html = el ? el.innerHTML : '';
            cache[h] = html; delete pending[h]; return html;
          }, function (e) { delete pending[h]; throw e; });
        return pending[h];
      }
      /* hand-picked products: one small request per product, in the chosen order; sold out ones come back empty */
      var pcache = {};
      function loadCard(h) {
        if (pcache[h] != null) return Promise.resolve(pcache[h]);
        return fetch(root() + 'products/' + encodeURIComponent(h) + '?view=s247-card', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw 0; return r.text(); })
          .then(function (t) { pcache[h] = /mlyn-card/.test(t) ? t : ''; return pcache[h]; });
      }
      function loadTab(t) {
        var list = (t.getAttribute('data-products') || '').split(',').filter(function (h) { return h && !hide[h]; });
        if (!list.length) return load(t.getAttribute('data-handle'));
        var key = 'p:' + list.join(',');
        if (cache[key] != null) return Promise.resolve(cache[key]);
        if (pending[key]) return pending[key];
        var fails = 0;
        pending[key] = Promise.all(list.slice(0, 16).map(function (h) { return loadCard(h).catch(function () { fails++; return ''; }); }))
          .then(function (parts) {
            delete pending[key];
            if (fails && fails === parts.length) throw 0;
            var html = parts.join('');
            if (!fails) cache[key] = html;
            return html;
          }, function (e) { delete pending[key]; throw e; });
        return pending[key];
      }
      function navState() {
        if (!prev || !next) return;
        prev.disabled = row.scrollLeft < 4;
        next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      }
      function show(html, failed) {
        row.classList.remove('is-out', 'is-in', 'is-loading');
        if (failed) row.innerHTML = '<p class="s247gp__empty">These products did not load. Use the button below to see them.</p>';
        else {
          row.innerHTML = html || '';
          if (!tidy()) row.innerHTML = EMPTY;
        }
        [].forEach.call(row.children, function (c, i) { c.style.setProperty('--i', Math.min(i, 6)); });
        row.scrollLeft = 0;
        void row.offsetWidth;
        row.classList.add('is-in');
        navState();
      }
      function skeleton() {
        var s = '';
        for (var i = 0; i < 5; i++) s += '<div class="s247gp__sk" aria-hidden="true"></div>';
        row.classList.remove('is-out', 'is-in'); row.classList.add('is-loading'); row.innerHTML = s;
      }
      function swapWord(txt) {
        if (!word) return;
        var my = ++wseq;
        if (reduce) { word.textContent = txt; return; }
        word.classList.remove('is-in'); word.classList.add('is-out');
        setTimeout(function () {
          if (my !== wseq) return;
          word.textContent = txt; word.classList.remove('is-out'); void word.offsetWidth; word.classList.add('is-in');
        }, 300);
      }
      function setTab(t) {
        if (t === cur) return;
        cur = t;
        var my = ++seq, h = t.getAttribute('data-handle');
        tabs.forEach(function (b) {
          var on = b === t;
          b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
        });
        stage && stage.setAttribute('aria-labelledby', t.id);
        moveInd(true); keepVisible(t);
        swapWord(t.getAttribute('data-word') || '');
        if (allA) { allA.href = t.getAttribute('data-url') || allA.href; allA.textContent = t.getAttribute('data-all') || allA.textContent; }
        if (stackA) {
          var g = t.getAttribute('data-stack');
          stackA.hidden = !g;
          if (g) stackA.href = root() + 'pages/build-your-stack?goal=' + encodeURIComponent(g);
        }
        row.classList.remove('is-in');
        if (!reduce) row.classList.add('is-out');
        var wait = new Promise(function (r) { setTimeout(r, reduce ? 0 : 190); });
        var sk = setTimeout(function () { if (my === seq) skeleton(); }, 240);
        Promise.all([loadTab(t), wait]).then(function (res) {
          clearTimeout(sk); if (my === seq) show(res[0]);
        }, function () { clearTimeout(sk); if (my === seq) show('', true); });
      }

      tabs.forEach(function (b, i) {
        b.addEventListener('click', function () { setTab(b); });
        var warm = function () { loadTab(b).catch(function () {}); };
        b.addEventListener('pointerenter', warm); b.addEventListener('focus', warm);
        b.addEventListener('touchstart', warm, { passive: true });
        b.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (k === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (k === 'Home') n = tabs[0];
          if (k === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); n.focus(); setTab(n); }
        });
      });
      [prev, next].forEach(function (b) {
        b && b.addEventListener('click', function () {
          var dir = parseInt(b.getAttribute('data-dir'), 10) || 1;
          try { row.scrollBy({ left: dir * row.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { row.scrollLeft += dir * row.clientWidth * 0.85; }
        });
      });
      var navT = 0;
      row.addEventListener('scroll', function () { if (!navT) navT = requestAnimationFrame(function () { navT = 0; navState(); }); }, { passive: true });
      w.addEventListener('resize', function () { moveInd(false); navState(); });
      if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { moveInd(false); });
      [].forEach.call(row.children, function (c, i) { c.style.setProperty('--i', Math.min(i, 6)); });
      box.classList.add('is-ready');
      moveInd(false); navState();
    });
  } catch (e) {}

  /* 8. homepage nearest store (sections/s247-near-you.liquid): Google map of the stores, "Use my location",
     distance and open now. The shopper's location never leaves the browser (it is not put into the Google map). */
  try {
    d.querySelectorAll('[data-s247ny]').forEach(function (box) {
      var data;
      try { data = JSON.parse(box.querySelector('[data-ny-data]').textContent); } catch (e) { return; }
      if (!data || !data.length) return;
      var sel = box.querySelector('[data-ny-select]'), gframe = box.querySelector('[data-ny-gmap]'), allBtn = box.querySelector('[data-ny-all]');
      var locBtn = box.querySelector('[data-ny-locate]'), locT = box.querySelector('[data-ny-locate-t]'), note = box.querySelector('[data-ny-note]');
      var msg = box.querySelector('[data-ny-msg]'), card = box.querySelector('[data-ny-card]'), extra = box.querySelector('[data-ny-extra]');
      var q = function (s) { return box.querySelector(s); };
      var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      var LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var STATE = { victoria: 'VIC', queensland: 'QLD', 'new south wales': 'NSW', 'south australia': 'SA', 'western australia': 'WA', tasmania: 'TAS' };
      var me = null, dist = null, cur = -1, gHome = gframe ? gframe.getAttribute('src') : '';

      function km(a, b, c, e) {
        var r = Math.PI / 180, x = Math.sin((c - a) * r / 2), y = Math.sin((e - b) * r / 2);
        var h = x * x + Math.cos(a * r) * Math.cos(c * r) * y * y;
        return 12742 * Math.asin(Math.min(1, Math.sqrt(h)));
      }
      function short(s) { return String(s.n || '').replace(/^Supps247\s*/i, ''); }
      function state(s) { return STATE[String(s.r || '').toLowerCase()] || s.r || ''; }
      function addr(s) { return [s.a, [s.c, state(s), s.p].filter(Boolean).join(' ')].filter(Boolean).join(', '); }
      function mins(t) { var m = /^(\d{1,2}):(\d{2})/.exec(t || ''); return m ? (+m[1]) * 60 + (+m[2]) : null; }
      function fmt(t) {
        var m = mins(t); if (m == null) return '';
        var h = Math.floor(m / 60) % 24, mi = m % 60;
        return (h % 12 || 12) + (mi ? ':' + (mi < 10 ? '0' : '') + mi : '') + (h < 12 ? ' am' : ' pm');
      }
      function status(s) {
        var hs = s.h;
        if (!hs || typeof hs !== 'object' || !w.Intl) return null;
        var o = {};
        try {
          new Intl.DateTimeFormat('en-AU', { timeZone: /queensland|qld/i.test(s.r || '') ? 'Australia/Brisbane' : 'Australia/Melbourne',
            weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
            .formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
        } catch (e) { return null; }
        var day = DAYS.indexOf(String(o.weekday || '').slice(0, 3).toLowerCase()), now = ((+o.hour) % 24) * 60 + (+o.minute);
        if (day < 0 || isNaN(now)) return null;
        var t = hs[DAYS[day]], op = t && mins(t[0]), cl = t && mins(t[1]);
        if (op != null && cl != null) {
          if (cl <= op) cl += 1440;
          if (now >= op && now < cl) return { open: true, t: 'Open now, closes ' + fmt(t[1]) };
          if (now < op) return { open: false, t: 'Closed now, opens ' + fmt(t[0]) + ' today' };
        }
        for (var k = 1; k <= 7; k++) {
          var di = (day + k) % 7, dd = hs[DAYS[di]];
          if (dd && mins(dd[0]) != null) return { open: false, t: 'Closed now, opens ' + fmt(dd[0]) + ' ' + (k === 1 ? 'tomorrow' : LONG[di]) };
        }
        return null;
      }
      function kmText(x) { return x < 10 ? x.toFixed(1) + ' km' : Math.round(x).toLocaleString('en-AU') + ' km'; }

      /* stores far from the rest (for example Queensland) are outside the map's starting view, so name them under it */
      var ok = [];
      data.forEach(function (s, i) { s.lat = +s.lat; s.lng = +s.lng; if (s.lat && s.lng && isFinite(s.lat) && isFinite(s.lng)) ok.push(i); });
      if (ok.length) {
        var la = ok.map(function (i) { return data[i].lat; }).sort(function (a, b) { return a - b; });
        var lo = ok.map(function (i) { return data[i].lng; }).sort(function (a, b) { return a - b; });
        var mLat = la[la.length >> 1], mLng = lo[lo.length >> 1];
        var offMap = ok.filter(function (i) { return km(mLat, mLng, data[i].lat, data[i].lng) >= 350; });
        if (extra && offMap.length) {
          extra.textContent = (extra.getAttribute('data-hint') || '') + ' ' + offMap.map(function (i) { return data[i].n + ' (' + (data[i].r || data[i].c || '') + ')'; }).join(', ') +
            (offMap.length > 1 ? ' are' : ' is') + ' outside this map view. Choose ' + (offMap.length > 1 ? 'them' : 'it') + ' from the list.';
        }
      }

      /* the Google map: all stores to start with, then the chosen store's own Google listing (name and address only) */
      function gShow(s) {
        if (!gframe) return;
        var url = s ? 'https://www.google.com/maps?q=' + encodeURIComponent((s.n || '') + ', ' + addr(s)) + '&z=15&output=embed' : gHome;
        if (gframe.getAttribute('src') !== url) gframe.setAttribute('src', url);
        gframe.setAttribute('title', s ? 'Google map of ' + s.n : 'Google map of Supps247 stores');
        if (allBtn) allBtn.hidden = !s;
      }
      allBtn && allBtn.addEventListener('click', function () { gShow(null); });
      function say(t) { if (!msg) return; msg.textContent = t || ''; msg.hidden = !t; }

      function pick(i, why) {
        var s = data[i]; if (!s) return;
        cur = i;
        if (sel) sel.value = String(i);
        var dx = dist ? dist[i] : null;
        q('[data-ny-dist]').textContent = dx != null && isFinite(dx) ? (why === 'near' ? 'Closest to you, ' : '') + kmText(dx) + ' away' : '';
        q('[data-ny-name]').textContent = s.n || '';
        var ig = q('[data-ny-ig]');
        if (ig) {
          if (s.ig) { ig.href = s.ig; ig.setAttribute('aria-label', (s.n || 'Supps247') + ' on Instagram'); ig.hidden = false; }
          else ig.hidden = true;
        }
        q('[data-ny-addr]').textContent = addr(s);
        var stt = status(s), op = q('[data-ny-open]');
        op.textContent = stt ? stt.t : ''; op.classList.toggle('is-open', !!(stt && stt.open));
        var dir = q('[data-ny-dir]'), more = q('[data-ny-more]');
        if (s.g) dir.href = s.g;
        if (s.u) more.href = s.u;
        dir.setAttribute('aria-label', 'Directions to ' + s.n + ' (opens Google Maps)');
        more.setAttribute('aria-label', s.n + ' details and opening hours');
        var also = q('[data-ny-also]'), list = q('[data-ny-alsolist]');
        if (dist) {
          var order = ok.slice().sort(function (a, b) { return dist[a] - dist[b]; }).filter(function (j) { return j !== i; }).slice(0, 2);
          list.innerHTML = '';
          order.forEach(function (j) {
            var b = d.createElement('button'); b.type = 'button'; b.className = 's247ny__chip';
            b.appendChild(d.createTextNode(short(data[j]) + ' '));
            var em = d.createElement('b'); em.textContent = kmText(dist[j]); b.appendChild(em);
            b.addEventListener('click', function () { pick(j, 'chip'); });
            list.appendChild(b);
          });
          also.hidden = !order.length;
        } else also.hidden = true;
        card.hidden = false;
        if (!reduce) { card.classList.remove('is-new'); void card.offsetWidth; card.classList.add('is-new'); }
        gShow(s);
      }

      sel && sel.addEventListener('change', function () { if (sel.value !== '') pick(+sel.value, 'list'); });

      if (locBtn && navigator.geolocation) {
        locBtn.hidden = false; if (note) note.hidden = false;
        var busy = false;
        locBtn.addEventListener('click', function () {
          if (busy) return;
          busy = true; locBtn.classList.add('is-busy'); if (locT) locT.textContent = 'Finding you...'; say('');
          navigator.geolocation.getCurrentPosition(function (pos) {
            busy = false; locBtn.classList.remove('is-busy'); if (locT) locT.textContent = 'Update my location';
            me = { lat: pos.coords.latitude, lng: pos.coords.longitude };
            dist = data.map(function (s, i) { return ok.indexOf(i) < 0 ? Infinity : km(me.lat, me.lng, s.lat, s.lng); });
            var near = ok.slice().sort(function (a, b) { return dist[a] - dist[b]; })[0];
            if (near == null) return;
            if (dist[near] > 300) say('You are a long way from our stores. The closest one is shown below.');
            pick(near, 'near');
          }, function (err) {
            busy = false; locBtn.classList.remove('is-busy'); if (locT) locT.textContent = 'Use my location';
            say(err && err.code === 1
              ? 'Location is turned off for this site. Choose a store from the list instead.'
              : 'We could not find your location just now. Choose a store from the list instead.');
          }, { enableHighAccuracy: false, timeout: 12000, maximumAge: 300000 });
        });
      }
    });
  } catch (e) {}

  /* 9. moving strips (header facts, brand logos, benefits, payment logos) speed up as you scroll and run backwards
     for a moment when you scroll up, then settle back to normal */
  try {
    if (!reduce && w.requestAnimationFrame) {
      var mqEls = [].slice.call(d.querySelectorAll('.mlyn-ticker-track, .marquee-container, .benefit-marquee-container'));
      if (mqEls.length && mqEls[0].getAnimations) {
        var mqList = null, mqY = w.pageYOffset, mqT = 0, mqBoost = 0, mqDir = 1, mqRaf = 0;
        var mqFind = function () {
          var a = [];
          mqEls.forEach(function (el) {
            el.getAnimations().forEach(function (x) {
              try { if (x.effect && x.effect.getComputedTiming().iterations === Infinity) a.push(x); } catch (e) {}
            });
          });
          return a;
        };
        var mqTick = function () {
          mqRaf = 0;
          mqBoost *= 0.93;
          if (mqBoost < 0.03) mqBoost = 0;
          var rate = 1 + mqBoost * mqDir;
          mqList.forEach(function (a) { try { a.playbackRate = rate; } catch (e) {} });
          if (mqBoost) mqRaf = requestAnimationFrame(mqTick);
        };
        w.addEventListener('scroll', function () {
          var y = w.pageYOffset, t = (w.performance && performance.now()) || Date.now();
          var dy = y - mqY, dt = Math.max(16, t - (mqT || t - 16));
          mqY = y; mqT = t;
          if (!dy) return;
          if (!mqList) mqList = mqFind();
          if (!mqList.length) return;
          mqDir = dy < 0 ? -1 : 1;
          mqBoost = Math.min(4, Math.max(mqBoost, Math.abs(dy) / dt * 1.6));
          if (!mqRaf) mqRaf = requestAnimationFrame(mqTick);
        }, { passive: true });
      }
    }
  } catch (e) {}

  /* 10. a thin blue line at the top of the homepage and blog posts shows how far down the page you are (CSS only) */
  try {
    if (!reduce && w.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()') &&
        d.querySelector('.theme-template-index, .theme-template-article')) {
      var pb = d.createElement('div'); pb.className = 's247-prog'; pb.setAttribute('aria-hidden', 'true');
      d.body.appendChild(pb);
    }
  } catch (e) {}

  /* 11. computers: the round category buttons grow under the pointer like a dock */
  try {
    if (!reduce && w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      d.querySelectorAll('.mlyn-goals-track').forEach(function (tr) {
        var items = [].slice.call(tr.querySelectorAll('.mlyn-goal'));
        if (items.length < 3) return;
        var raf = 0, px = 0, on = false;
        tr.classList.add('s247-dock');
        var frame = function () {
          raf = 0;
          items.forEach(function (it) {
            var r = it.getBoundingClientRect(), f = on ? Math.max(0, 1 - Math.abs(px - (r.left + r.width / 2)) / 190) : 0;
            it.style.setProperty('--s247-dock', (1 + 0.15 * f * f).toFixed(3));
          });
        };
        tr.addEventListener('pointermove', function (e) { px = e.clientX; on = true; if (!raf) raf = requestAnimationFrame(frame); }, { passive: true });
        tr.addEventListener('pointerleave', function () { on = false; if (!raf) raf = requestAnimationFrame(frame); });
      });
    }
  } catch (e) {}
  /* 12. online deal countdowns (snippets/s247-deal-clock.liquid): count down every second to the real end time,
     then hide the deal and show the normal price. Never restarts. */
  try {
    var dls = [].slice.call(d.querySelectorAll('[data-s247-deal]'));
    if (dls.length) {
      var dPad = function (n) { return (n < 10 ? '0' : '') + n; };
      var dEndTxt = function (t) {
        try { return 'Ends ' + new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', weekday: 'short', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' }).format(new Date(t)) + '.'; }
        catch (e) { return ''; }
      };
      var dLive = [];
      dls.forEach(function (el) {
        var end = Date.parse(el.getAttribute('data-end') || '');
        if (!end || isNaN(end)) return;
        var et = el.querySelector('[data-end-text]'); if (et) et.textContent = dEndTxt(end);
        dLive.push({ el: el, end: end, d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]'), last: -1 });
      });
      var dFinish = function (x) {
        x.done = true; x.el.hidden = true;
        var box = x.el.parentNode, after = box && box.querySelector('[data-s247-deal-after]');
        if (after) after.hidden = false;
        var sec = x.el.closest('section'), k = sec && sec.querySelector('[data-s247-deal-kicker]');
        if (k) k.hidden = true;
      };
      var dTimer = 0;
      var dTick = function () {
        var now = Date.now(), any = false;
        dLive.forEach(function (x) {
          if (x.done) return;
          var left = Math.floor((x.end - now) / 1000);
          if (left <= 0) { dFinish(x); return; }
          any = true;
          var dd = Math.floor(left / 86400), hh = Math.floor(left % 86400 / 3600), mm = Math.floor(left % 3600 / 60), ss = left % 60;
          if (x.d) x.d.textContent = dd;
          if (x.h) x.h.textContent = dPad(hh);
          if (x.m) x.m.textContent = dPad(mm);
          if (x.s && x.last !== ss) {
            x.s.textContent = dPad(ss); x.last = ss;
            if (!reduce) { x.s.classList.remove('is-tick'); void x.s.offsetWidth; x.s.classList.add('is-tick'); }
          }
        });
        if (!any && dTimer) clearInterval(dTimer);
      };
      dTick();
      dTimer = setInterval(dTick, 1000);
    }
  } catch (e) {}
})();

/* 13. 11 Oct 2026: navy product panels across the site (same look as the homepage deal panels). Collection and search
   product grids, "You Might Also Like" on collection pages and "Level Up Your Supps!" on product pages get the class
   s247-panel and a big outlined word (data-s247-word, drawn by CSS so it survives the grid's AJAX search and paging). */
(function () {
  function run() {
    try {
      var mark = function (el, word) {
        if (!el || el.classList.contains('s247-panel')) return;
        el.setAttribute('data-s247-word', String(word || '').trim().slice(0, 18));
        el.classList.add('s247-panel');
      };
      var grid = document.getElementById('product-grid-container');
      if (grid) {
        var w = '';
        if (location.pathname.indexOf('/search') === 0) {
          w = ((new URLSearchParams(location.search).get('q') || '').trim().split(/\s+/)[0]) || 'Search';
        } else {
          var h = document.querySelector('#MainContent h1');
          var t = (h ? h.textContent : '').trim().split(/\s+/).filter(Boolean);
          w = t[0] || 'Shop';
          if (w.length < 4 && t[1]) w += ' ' + t[1];
        }
        mark(grid, w);
      }
      document.querySelectorAll('.ymal-slider').forEach(function (s) { mark(s.parentElement, 'More'); });
      var levelUp = function () { document.querySelectorAll('.mlyn-level-up-recommendations .mlyn-products-grid').forEach(function (g) { mark(g, 'Level up'); }); };
      levelUp();
      /* "Level Up Your Supps!" swaps in its products when it scrolls into view, so mark the new grid when that happens */
      if ('MutationObserver' in window) {
        document.querySelectorAll('.mlyn-level-up-recommendations').forEach(function (box) {
          var queued = false;
          new MutationObserver(function () {
            if (queued) return; queued = true;
            requestAnimationFrame(function () { queued = false; levelUp(); });
          }).observe(box, { childList: true, subtree: true });
        });
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

} catch (e) { if (window.console) console.warn("s247-fx new", e); }
